// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-26T20:54:33.879Z
// Property: Preferred (ID: 6767906449167742)
// Collections: 149 amenities, 37 floorplans (live), 59 photos, 75 POIs, 60 reviews, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5760613594693632",
  "multihub_property_id": "6767906449167742",
  "property_external_id": "v90efmg",
  "property_zillow_url": "https://www.zillow.com/apartments/atlanta-ga/ascent-midtown/CjrV6n/",
  "property_apartments_url": "https://www.apartments.com/ascent-midtown-atlanta-ga/v90efmg/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "preferred",
  "property_name": "Preferred",
  "property_website_url": "https://preferred-theme-demo.multiscreensite.com/",
  "property_domain": null,
  "property_address": "1131 Courtney Trace Dr",
  "property_full_address": "1131 Courtney Trace Dr, Brandon, FL 33511",
  "property_address_1": "1131 Courtney Trace Dr",
  "property_address_2": null,
  "property_address_city": "Brandon",
  "property_address_state": "FL",
  "property_address_zip_full": null,
  "property_address_zip": "33511",
  "property_address_country": "US",
  "property_address_county": "Hillsborough County",
  "property_neighborhood_address": "Midtown Atlanta",
  "property_address_latitude": "27.9196491",
  "property_address_longitude": "-82.3319635",
  "property_email": null,
  "property_phone": "false",
  "property_call_tracking_phone": null,
  "property_company_name": "Rebel Residential",
  "property_company_url": null,
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Elevate everyday living at Preferred.</strong> This upscale modern high-rise pairs iconic architecture, extraordinary residences, and best-in-class amenities with walkable access to city experiences and a central metropolitan address.</p>",
  "property_long_description": "<p><strong>Modern Brandon living with room to spread out.</strong> At Preferred, you can choose from comfortable one-, two-, and three-bedroom apartments, including townhome-style layouts, and come home to finishes designed for easy everyday living—granite or quartz countertops, premium appliances, wood-style flooring, smart-home features, generous closets, and in-home washer and dryer convenience. Explore the <a href=\"/floor-plans\">available floor plans</a> to find the layout that fits your day.</p><p>Beyond your front door, <a href=\"/amenities\">two resort-style pools</a>, poolside sundecks, two fitness centers, a resident clubhouse, conference rooms, grilling areas, package lockers, garages, and a leash-free bark park give you practical perks with a relaxed Florida feel. The location keeps Brandon’s best close by, from Lumsden Road dining like Tibby’s New Orleans Kitchen and Bonefish Grill to shopping at Brandon Exchange and green space at Paul Sanders Park. With I-75 and the Selmon Expressway nearby, downtown Tampa, Ybor City, and Tampa Bay destinations stay within reach.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
    "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
    "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
    "width": 1920,
    "height": 1281
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "328",
  "property_year_built": "2018",
  "property_year_renovated": null,
  "property_walk_score": "83",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "90.85365853658537",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "150",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "All breeds welcome!",
  "property_pet_policy_description": "One-Time Pet Fee: $150. Monthly Pet Rent: $50. Pet Limit: 2. All breeds welcome!",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e59-e3ea-7225-ae53-dadf35aaf2c7.webp",
  "property_primary_logo_media": {
    "alt_text": "Preferred Parkside Living logo",
    "public_id": "01a03e59-e3ea-7225-ae53-dadf35aaf2c7",
    "storage_key": "property/6767906449167742/01a03e59-e3ea-7225-ae53-dadf35aaf2c7.webp",
    "width": 300,
    "height": 67
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-61bf-73ea-8135-e9dde1b9691e.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a03e5a-61bf-73ea-8135-e9dde1b9691e",
    "storage_key": "property/6767906449167742/01a03e5a-61bf-73ea-8135-e9dde1b9691e.webp",
    "width": 300,
    "height": 67
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-47f1-77cf-bc5e-02a173600e42.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a03e5a-47f1-77cf-bc5e-02a173600e42",
    "storage_key": "property/6767906449167742/01a03e5a-47f1-77cf-bc5e-02a173600e42.webp",
    "width": 300,
    "height": 67
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5760613594693632/01a03915-19b6-71d4-aeb8-805d7480607e.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#2b3747",
  "property_secondary_color": "#e4eff4",
  "property_font_color": "#1a1a1a",
  "property_color_4": "#ffffff",
  "property_color_3": "#f5f5f5",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 2",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "610 - 1,459 sq ft",
  "property_sqft_min": "610",
  "property_sqft_max": "1,459",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 30,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJzzedY1AE9YgRfqVwP3IXcrY",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Preferred ",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection in Your New Home",
  "property_home_amenities_blurb": "<p><strong>Elevated amenities, polished at every turn.</strong> Preferred pairs everyday ease with destination-style spaces, including 24-hour concierge service, high-speed elevators, Amazon package lockers, covered garage parking, and controlled entry. Take in skyline views from the 28th-floor lounge, unwind on the 7th-floor terrace with a saltwater pool, cabanas, grills, and sundeck, or recharge in the 4,000-square-foot fitness center with Peloton™ bikes. Inside, chef-caliber kitchens, quartz countertops, glass balconies, and spa-style baths complete the experience.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to rise.</strong> At Preferred, choose from streamlined studios, spacious one- and two-bedroom residences, and penthouse layouts with upgraded finishes. Inside, open designs, 9’ ceilings, framed glass balconies, solar shades, full-size washers and dryers, and walk-in closets with wood shelving bring brightness and ease to every day.</p>",
  "property_home_gallery_blurb": "<p><strong>See Preferred in focus.</strong> Preview bright interiors, open living spaces, polished kitchen counters, sleek appliances, and islands made for gathering. The gallery also highlights everyday conveniences, smart storage, and select patios or balconies.</p><p>Look closer at the pool, shaded sundeck, fitness center, clubhouse, grilling areas, landscaped paths, and pet-friendly touches that shape the Brandon community experience.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Midtown energy is right outside your door.</strong> From Preferred, stay close to Tech Square, West Peachtree dining, Colony Square’s Politan Row, MARTA, Piedmont Park, the Fox Theatre, Woodruff Arts Center, and the High Museum—then come home to high-rise views and spaces designed for a recharge. Explore the neighborhood map to see what’s nearby.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents notice the service.</strong> Reviews frequently praise Ebony, Diego, Taye, and Tameka for welcoming, knowledgeable, and caring support. Guests also call out the beautifully maintained community, scenic views, spacious apartments with modern finishes, and quick, reliable maintenance—everyday details that make the experience stand out.</p>",
  "property_neighborhood_blurb": "<p><strong>Step into Midtown’s everyday energy.</strong> From Preferred, you’re surrounded by the places that give Atlanta’s core its pulse—Tech Square, West Peachtree dining, Colony Square’s Politan Row and patio scene, and MARTA access for easy trips across the city.</p><p>Spend an afternoon under the trees at Piedmont Park, catch a performance at the Fox Theatre or Woodruff Arts Center, browse the High Museum, then return to high-rise views and resident spaces made for recharging. Explore the map to see what is close by, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the Midtown address in person.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities with altitude and intention.</strong> Preferred layers daily convenience with destination-style spaces, from 24-hour concierge service and high-speed elevator access to Amazon package lockers, covered garage parking, and controlled entry. Above it all, the 28th-floor resident lounge frames sweeping Midtown Atlanta views, while the 7th-floor terrace brings together a saltwater pool, custom cabanas, an outdoor kitchen, grills, and an expansive sundeck.</p><p>Inside, your home keeps the same polished pace with chef-caliber kitchens, gas ranges, quartz countertops, USB-equipped islands, full-size washers and dryers, framed glass balconies, solar shades, and spa-style baths. Recharge in the 4,000-square-foot fitness center with Peloton™ bikes, meet in the business and conference areas, unwind by the fireplace lounge, or explore the pet oasis with spa and indoor play space. See more in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Elevate your next address.</strong> Apply online for an upscale, modern high-rise experience with iconic architecture, extraordinary residences, and best-in-class amenities—all in a central, walkable location connected to city energy and everyday convenience.</p>",
  "property_contactus_blurb": "<p><strong>Questions? We’re here to help.</strong><br>Contact the leasing team to learn more about Ascent Midtown’s upscale high-rise living, modern residences, and best-in-class amenities—or reach out for directions to this central metropolitan address.</p>",
  "property_faqs_blurb": "<p><strong>Questions before you elevate your everyday?</strong> Explore answers about Ascent Midtown’s community, leasing details, amenities, and modern high-rise living. If you need anything more, the leasing team is happy to help you find the information you need.</p>",
  "property_floorplans_blurb": "<p><strong>Find the fit that rises to your routine.</strong> At Preferred, floor plans range from streamlined studios to spacious one- and two-bedroom residences, including penthouse options with upgraded finishes. Open layouts, 9’ ceilings, framed glass balconies, and solar shades help each home feel bright and considered, while full-size washers and dryers, walk-in closets with wood shelving, and programmable thermostats add everyday ease.</p><p>Choose the kitchen style that suits how you cook and gather, with chef-caliber details like gas ranges, quartz countertops, sleek cabinetry, USB outlets in islands, and stainless steel undermount sinks. Compare current pricing and availability, then view more <a href=\"/gallery\">apartment photos</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite Midtown Atlanta layout in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture the details that make Preferred feel inviting.</strong> Browse the gallery for sunlit interiors, open living areas, and kitchens with polished counters, sleek appliances, and room to gather around the island. Each image gives you a closer look at the finishes, storage, and everyday conveniences that shape life at this Brandon community.</p><p>Step outside through the photos and imagine time by the pool, shaded moments on the sundeck, a workout in the fitness center, or a casual break in the clubhouse and outdoor grilling spaces. You can also spot pet-friendly touches, landscaped paths, and select patios or balconies that extend your space outdoors. When you’re ready to compare layouts, view <a href=\"/floor-plans\">available floor plans</a>, explore more through <a href=\"/virtual-tours\">virtual tours</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Ascent Midtown from above.</strong> Use the interactive map to view <a href=\"/floor-plans\">available apartments</a> and see how this modern high-rise connects you to Midtown’s walkable access, top employers, exciting city experiences, and the greater Atlanta metropolitan area.</p>",
  "property_pets_blurb": "<p><strong>Bring the whole pack.</strong> Preferred makes pet-friendly apartment living feel easy, from an all-breeds-welcome policy to everyday spaces that help your companion settle in. Start mornings with time in the pet play area, rinse off after outdoor adventures at the pet washing station, and enjoy convenient features like controlled access, package service, and on-site management that keep daily routines moving.</p><p>When you want a change of scenery, nearby options for pet supplies, grooming, veterinary care, and off-leash play around Brandon make quick errands and weekend outings simple. Explore more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Preferred supports life with pets.</p>",
  "property_referafriend_blurb": "<p><strong>Share the view from Ascent Midtown.</strong> Invite a friend to experience upscale high-rise living with iconic architecture, extraordinary residences, best-in-class amenities, and walkable access to Atlanta’s city energy from a central Midtown address.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Ascent Midtown.</strong><br>From this upscale modern high-rise, managing home is simple. Pay rent, submit maintenance requests, and handle account details online—so you can stay focused on the elevated living experience, iconic design, and brilliant city convenience that define Ascent Midtown.</p>",
  "property_reviews_blurb": "<p><strong>Hear it from the people who know the experience best.</strong> As you read the reviews, you’ll see recurring praise for a team that makes every interaction feel welcoming, informed, and personal. Residents and tour guests consistently call out Ebony, Diego, Taye, and Tameka for patience, professionalism, and genuine care.</p><p>Reviewers also highlight a beautiful, well-maintained property, stunning views, spacious apartments with modern finishes, and “quick and reliable maintenance.” From personalized tours to everyday support, the feedback points to a Midtown Atlanta living experience where questions are answered clearly, requests are handled with attention, and service is a true standout.</p>",
  "property_created_at": "1787752414355",
  "property_scheduletour_blurb": "<p><strong>See Ascent Midtown in person.</strong> Tour an upscale, modern high-rise with iconic architecture, extraordinary residences, and best-in-class amenities—all set at a central Midtown address with walkable city access. Schedule your visit and experience how elevated Atlanta living looks from here.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong> The leasing team will follow up soon with next steps. In the meantime, picture life elevated at Ascent Midtown: an upscale, modern high-rise with iconic architecture, extraordinary residences, and a central Atlanta location designed for a sophisticated city lifestyle.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through Preferred before you arrive.</strong> Start with the community and entrance tours, then move at your own pace through studio, one-bedroom, and two-bedroom apartment walkthroughs. Each virtual tour helps you understand the flow from room to room—how the kitchen connects to the living area, where storage fits into the day, and how natural light shapes the space.</p><p>Use these tours to compare layouts side by side, narrow your favorites on the <a href=\"/floor-plans\">floor plans</a> page, and get a clearer feel for finishes like sleek cabinetry, stone-style counters, wood-style flooring, and in-home laundry features. When a walkthrough feels like the right match, <a href=\"/schedule-a-tour\">schedule a tour</a> to see Preferred in Brandon in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Preferred ",
  "property_seo_title_home": "Preferred  |  Apartments in Atlanta, GA",
  "property_seo_description_home": "Experience luxury living at Preferred Apartments in vibrant Atlanta! Enjoy city views, stylish designs, and top-notch amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Atlanta, GA Apartments for Rent",
  "property_seo_description_floorplans": "Uncover your ideal living space at Preferred in Atlanta, GA. Choose from cozy studios, spacious one or two-bedroom layouts—your perfect floor plan awaits!",
  "property_seo_title_amenities": "Amenities | Atlanta, GA Apartments for Rent",
  "property_seo_description_amenities": "Unwind in upscale Atlanta living at Preferred. Discover spacious floor plans, luxurious amenities, and a vibrant community designed for your lifestyle.",
  "property_seo_title_gallery": "Gallery | Apartments in Atlanta, GA",
  "property_seo_description_gallery": "Experience luxury in Atlanta at Preferred Apartments! From stylish studios to spacious two-bedrooms, enjoy top amenities and stunning views.",
  "property_seo_title_virtualtours": "Virtual Tours | Preferred  Apartments",
  "property_seo_description_virtualtours": "Experience Atlanta living at Preferred! Take a virtual tour of our stunning studio, one, and two-bedroom apartments. Find your perfect home today!",
  "property_seo_title_interactivemap": "Interactive Map | Preferred  Apartments",
  "property_seo_description_interactivemap": "Discover your ideal Atlanta home at Preferred! Use our interactive map to explore stylish studios and 1-2 bedroom apartments with premium amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Atlanta, GA",
  "property_seo_description_neighborhood": "Uncover the charm of Atlanta living at Preferred. Dive into our vibrant neighborhood filled with local favorites and hidden gems right outside your door!",
  "property_seo_title_contact": "Contact Us | Preferred ",
  "property_seo_description_contact": "Connect with our leasing team at Preferred in Atlanta, GA. From cozy studios to spacious two bedrooms, we have the perfect floor plan for you!",
  "property_seo_title_faqs": "FAQs | Apartments in Atlanta, GA",
  "property_seo_description_faqs": "Find answers to your burning questions about Preferred Apartments in Atlanta, GA. Learn about amenities, floor plans, and more. Your ideal home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Atlanta, GA",
  "property_seo_description_reviews": "Join Atlanta's vibrant Preferred community! Discover genuine resident reviews and see why our stylish homes and amenities make living exceptional!",
  "property_seo_title_applynow": "Apply Now | Apartments in Atlanta, GA",
  "property_seo_description_applynow": "Discover modern living at Preferred in Atlanta! Choose stylish studios or spacious two-bedrooms with top-notch amenities. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Preferred ",
  "property_seo_description_residentaccess": "Unlock convenience at Preferred in Atlanta! Access your resident portal to pay rent, schedule maintenance, and enjoy stress-free living today!",
  "property_seo_title_referafriend": "Refer A Friend | Preferred ",
  "property_seo_description_referafriend": "Refer a friend to Preferred in Atlanta, GA! Great friends make great neighbors—share the experience of a vibrant community and enjoy exclusive rewards!",
  "property_seo_title_scheduletour": "Schedule a Tour | Preferred ",
  "property_seo_description_scheduletour": "Experience urban living in Atlanta at Preferred. Schedule a tour today and step into your dream apartment community, where comfort meets convenience!",
  "property_seo_title_privacy": "Privacy Policy | Preferred ",
  "property_seo_description_privacy": "Your privacy matters! Learn how we protect your data at Preferred in Atlanta, GA. Stay informed and secure with our comprehensive privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Preferred ",
  "property_seo_description_accessibility": "At Preferred in Atlanta, GA, we prioritize digital accessibility for all, fostering an inclusive community where everyone feels welcome!",
  "property_seo_title_sitemap": "Sitemap | Preferred ",
  "property_seo_description_sitemap": "Navigate your way to comfort at Preferred in Atlanta, GA. Check out our sitemap to find your perfect home and all the amazing community features we offer!",
  "property_seo_title_thankyou": "Thank You | Preferred ",
  "property_seo_description_thankyou": "Thank you for reaching out to Preferred in Atlanta! Our team will connect with you soon to share your journey toward exceptional apartment living.",
  "property_seo_title_pets": "Pet Policy | Apartments in Atlanta, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787754060845",
  "amenities": [
    {
      "id": "ec_18ec84b86d0e58646492520a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "24 Hour Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_712192688bf581980eed6867",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d2b946e94c606b1e30c1a47",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Concierge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0dd0d0425471954338d504f6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ebd7cada4ea93dfc5d45329a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_03643eaf65f04ebe8c591da5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Video Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cda11c81baca14c132bab629",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Dry Cleaning Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f412f7ea69344ee6413e8c4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Furnished Units Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e09bdaa86e22df430211e16",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Laundry Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e2f4462a7ff889bd84431066",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Maid Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7ca36a78eedf717cd8cf0c7a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "On-Site Retail",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e67a121b9343f3a7c47913c8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Package Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_191d5c27151c418063c0da31",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Play Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_42b10fac265ce317017bb628",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f94067c55b4e4e18e7d56248",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9d4851e72ca9afc4176f150",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Trash Pickup - Curbside",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5ece37326252efed3f902571",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d9df8706bc029c3ef9ba9ce8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Car Charging Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_65154f94d55e5f60733bb02d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Grocery Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_abd2084df878512d5cc5130d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_488b89066a019a9ba93fac91",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Meal Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fec94e89336f87ece4d7dfa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "On-Site ATM",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed9566209d6b4dcdeb06f939",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Online Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_adac975c813b68a0f8e9b9ec",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Care",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1dcf61fb677b3dd3e759d7de",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Washing Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b349f74bb812462c2a0e3d90",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8b079a1d7b6a4d38a40bb382",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Key Fob Entry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea6885a79ca98bcb7dbc9dd1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_126b9c2d5869ecbf607066a1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ebb7248997eeea05ad1c85f6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Corporate Suites",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9cbe7fde3ce561940985ea3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Breakfast/Coffee Concierge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e3523964590647aa0cd6e7b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal Chutes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_01750a36a2f4532d42889820",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9de80b1ca6a3022d6ed5fbb6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Conference Rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_49ab81d94b500a053268356d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1135aa33bbd752eae5458836",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_506770717580faac410e3980",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Multi Use Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7d9989ff34e4f2deb2b99f8a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cb38733f500f2e64a606ba09",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31ad5de2036cb4690d901088",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db6a4054a36c8040e7ebf825",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_86e391e8696bd0cb3c4a9241",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Roof Terrace",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2e800a0c3b757b821907856e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c133e940e7731345d4397df2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_05e21cf7043e2c3903c188c4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d9c4add4b2fefe7aa841e191",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Media Center/Movie Theatre",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e402e00cdd3a94349cfcea3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Bicycle Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7624c533bccfe20aaf2060d8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Study Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_22965ef829953a188f908711",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk To Campus",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51311866814d106d47105cf8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "24-hour resident concierge services for your convenience",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b9e79dc22863ad1712b10292",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "28th Floor Resident Lounge With Views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d771b71645ff2530af3b6cb1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "3 floors of penthouse living w/ upgraded features & finishes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5992006dc3d6a368b43c1fd0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "4,000 SF Fitness Center W/Peloton Bikes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_82e934f261b28f0c31af9bf4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "4,000 SF, state-of-the-art fitness center feat Peloton™",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_39b18aae2cf8d5c77084ac69",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "7th floor terrace w/ luxe pool & custom cabanas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_46d2fe78969315909ab5590f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "7th Floor Terrace W/Saltwater Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb8f06bb8c5ebf5b31e710a7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "9' ceilings",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0bdcd6b0c0484f08e1dca4b7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "9' Ceilings & Open Floorplans",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_adcad8105ecc9cb851947973",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "9’ ceilings & open floor plans for ample natural light",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ec9817ca6c239d10cf8a650",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Amazon Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da4902c803f1fb34670cb9cd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Bar area perfect for cooking and entertaining",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e00cfa45182848885498df18",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Bluetooth Keyless Door Locks",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e3b0a34d51e30a160c62b63",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Chef-Caliber Kitchens",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_503c18e4e8ab49bd475652f7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Chef-caliber kitchens featuring sleek cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c91cfd2708df20f35ec58edc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled access community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43d2f407aed370084b7a89a7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Covered Garage Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7b1e77ba2d8356036c6826fb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Cozy Fireplace Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac3f75fff2908a4646e5c461",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Designer Ceiling Fans In Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0db815b5037fafb99f1314df",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Efficient Gas Cooking Ranges",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0dc89ad82a40d60a571a99e6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Expansive Sun Deck With Lounge Seating",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7855f8160a47a4d26b36bcd3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Fireplace lounge great for hanging with friends",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1167394899e688dc5b00ab24",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness On Demand Programs",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_11f9c23b6797381f9420e86b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Framed Glass Balconies",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2a7767a20bf92c831b7bcdc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Framed glass balconies for unobstructed views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b62644e75144be9a0e976f4f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Full-size, washer & dryer included in each residence",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_909781336b809abd3831c1d7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Gas cooking and quartz countertops",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_859954c082bcbece447c8eba",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Gas Stoves",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_94825ac1576499494bbb76d6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Glass Showers W/Porcelanosa Tile",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a89328b01481a04ae648625d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Glass showers with porcelanosa tile surrounds",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_27febb3be3b06518675902ea",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "High speed elevator access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1bb0ff3b2cb5ce14ef3f0da5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "High-Speed Elevator Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_54285f3ace5908b4930891d9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Incredible Midtown Atlanta location",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_528a2c753abbcf1aaaa10db5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Luxurious spa baths w/ granite counters and halo lit mirrors",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c7662d91df5c6572af5a8110",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Other",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6dd0f402b92ecc02da77033a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Outdoor Kitchen W/BBQ Grills",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c622bed8455820db8cce54cc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Pendant light fixtures in dining areas *",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cace1ba2fa62bae440bd0ab6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Penthouses Available W/Upgraded Finishes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7893f67f09733d40666800b1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Oasis W/Spa & Indoor Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b165f6d20de279c2bd7afad1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Plank, Wood-Style Flooring",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc2941fb3f85e4175f74c83f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Programmable Thermostat Technology",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f18bc72b80ce4c1fbd44a3ab",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Programmable thermostats technology",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f63a77518c198d665f17589b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Resident lounge on 28th floor with spectacular city views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d0389cf6f87d9d76ffad1c7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Sleek Black Slate Appliance Package",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_809c4f14c2f714d92fc761c5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Sleek Cabinetry & Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b53f5dde41e891b3ce9d2791",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Solar shades included in each home",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7163e0766d7f24a0f192a1e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Solar Shades Included In Every Home",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_49f2470da04cfcd84b1d68ed",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Spa baths w/ granite counters and halo lit mirrors",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_55db0ee2cfcc504052c7f62d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Spacious walk-in closets w/ wood shelving for extra storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be2b757e44fb098e37d7ded4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless steel",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_02b3ace5ee4228452a033074",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Undermounted sink with pull down Faucet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4bb0ec6ee0e6dcbe2c2dd21d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless steel, undermounted sink with pull down faucet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d90faf51d64456f9c98f708",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Studio, one, one & two-bed residences",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a38e3f29c5f9fb8bc5e71a39",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Stylish Pendant Lighting",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b72ea628c682e10564b57f9b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Summer kitchen including grills and outdoor dining",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b9da6f184c5023bf9755c455",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Tile-inspired floors in kitchen, living and dining rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_93e92baf197314b11c0ad17a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "USB Outlets In Kitchen Islands",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f36ba148442337c0ade43503",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "USB outlets in the kitchen island",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a40006e3ec114599ff4e0b3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "We offer both the vinyl plank and real wood flooring in our Penthouses",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b51167786b20694125b6788e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Whirlpool™ black slate appliance suite *",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c5bfb340c9498e3e424f4893",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_67a6926b5b46e7eb161f57de",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f706d168cf6f8b4c8b58cfe8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e15c20c73a23c25e3279a556",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b1c38b895f24dbc029f708a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_84636e2c5dbc92bda45c6647",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b93646eff44cfc6717ffc80",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_656b3210d01116e08fd8b061",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Double Vanities",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1746fef347167aedf79101cb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3437d68fd8a900b35998dcc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6ee5b8dcfbda85d3dbeb3bc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb52be65e8bdf04398a6640d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Framed Mirrors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8cc8c0007ee58197c8c07ff",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Wheelchair Accessible (Rooms)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c42ce4cc4d7135a2d2dd4fab",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e527ffb292268c1f8c0db5e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3362022c74feaf4cf4d9720",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53f8b99c717600fec1403650",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fd4c7ee5d5220792069f6b70",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_91671c094c7e06a351278824",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Ice Maker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80a4b7a498230ee22100fac0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_67a9c9f1fca5f7e9bec9be32",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_beef9f177f869b909f85ac89",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a525217ba3dfbf54f27b6e3a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df3e5bb53f01f40a82c1f817",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Freezer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_28996b40403e8942e485a168",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Island Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e3324190e31a002ebbe348ce",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb1f855ec82e32811b7cf3a0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Tile Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7428f8a4a08190d6333796fb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_749aca36fba7c7a951aa3bdd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8434e3e4eca18021ab3a9bca",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a4eaffd0936e15686f22a18",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Carpet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_259c0ba6bad169798a8e186a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Built-In Bookshelves",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1f01019481266a3bfd5cf9a2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Den",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3373baf5b4d490b0420e456",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Double Pane Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a6613892c45b57620090555",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e562cb3672dc52470e145942",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Office",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c353a037dfc237c07e431a17",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dafab9aa9d301830a58cd918",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Large Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aefd16f1678de2c8a6c01a57",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_584882b398e1ad20692dcfbe",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "apartments",
      "external_id": "false",
      "title": "Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_476089bb9c94de89bd40afa0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-7c18-70c9-85dd-cb40568ff7ca.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and city skyline view",
        "public_id": "01a03e5c-7c18-70c9-85dd-cb40568ff7ca",
        "storage_key": "property/6767906449167742/01a03e5c-7c18-70c9-85dd-cb40568ff7ca.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Relax by the stunning outdoor swimming pool, complete with comfortable lounge chairs and a breathtaking city skyline backdrop.",
      "link": "false",
      "alt_text": "Luxury swimming pool with lounge chairs and city skyline view",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/6RE5ygZ3ydSz3Tw2bsyp3kOkgzZ3o7EnxORvOwbdxqc/102/image.jpg"
    },
    {
      "id": "ec_c14023da8c6178f611726f71",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-7c18-70c9-85dd-cb40568ff7ca.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and city skyline view",
        "public_id": "01a03e5c-7c18-70c9-85dd-cb40568ff7ca",
        "storage_key": "property/6767906449167742/01a03e5c-7c18-70c9-85dd-cb40568ff7ca.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Relax by the stunning outdoor swimming pool, complete with comfortable lounge chairs and a breathtaking city skyline backdrop.",
      "link": "false",
      "alt_text": "Luxury swimming pool with lounge chairs and city skyline view",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/6RE5ygZ3ydSz3Tw2bsyp3kOkgzZ3o7EnxORvOwbdxqc/102/image.jpg"
    },
    {
      "id": "ec_d75a53d1f64aede95525eb71",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-6744-7006-b432-cc479a823ab8.webp",
      "image_media": {
        "alt_text": "High-rise apartment building exterior with balconies and large windows.",
        "public_id": "01a03e5c-6744-7006-b432-cc479a823ab8",
        "storage_key": "property/6767906449167742/01a03e5c-6744-7006-b432-cc479a823ab8.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Modern high-rise apartment building with many floors, featuring balconies and expansive windows, set against a clear blue sky.",
      "link": "false",
      "alt_text": "High-rise apartment building exterior with balconies and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/3ihoyY3f_RB9dzMS_iZvQOBeAS33C0uohitEZF-PnWA/102/image.jpg"
    },
    {
      "id": "ec_bb19bd281aaa56393bbdcf21",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-6178-75b8-8098-a7dfff9aaa49.webp",
      "image_media": {
        "alt_text": "Exterior of a modern high-rise apartment building with balconies and large windows, under a clear blue sky.",
        "public_id": "01a03e5c-6178-75b8-8098-a7dfff9aaa49",
        "storage_key": "property/6767906449167742/01a03e5c-6178-75b8-8098-a7dfff9aaa49.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Capturing the impressive facade of this modern high-rise, this image showcases the exterior of the apartment building, highlighting its sleek design and numerous private balconies.",
      "link": "false",
      "alt_text": "Exterior of a modern high-rise apartment building with balconies and large windows, under a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/16BwNIJbNxF64CZoZUCy92Yf_73QK7bvQeXBtBnyNn4/111/image.jpg"
    },
    {
      "id": "ec_95b5c2bd72389e10cbd34e96",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-61ec-7311-b169-c8c7fa174886.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with stainless steel appliances and balcony access.",
        "public_id": "01a03e5c-61ec-7311-b169-c8c7fa174886",
        "storage_key": "property/6767906449167742/01a03e5c-61ec-7311-b169-c8c7fa174886.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "A contemporary apartment kitchen featuring sleek cabinetry, stainless steel appliances, and a private balcony, perfect for enjoying city views.",
      "link": "false",
      "alt_text": "Modern apartment kitchen with stainless steel appliances and balcony access.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/HgcTzVdD9XVnxnb9Jk4_jqlo97nrviIkCMyMQRGHcz4/117/image.jpg"
    },
    {
      "id": "ec_4bc21041ea8ed8512ef5acce",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-4843-73e8-b722-86a3319cfa83.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and sleek grey cabinetry.",
        "public_id": "01a03e5c-4843-73e8-b722-86a3319cfa83",
        "storage_key": "property/6767906449167742/01a03e5c-4843-73e8-b722-86a3319cfa83.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed kitchen featuring stainless steel appliances, contemporary grey cabinetry, and ample counter space for all your culinary needs.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and sleek grey cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/mc_COKWOt4RHUbzpRL8fzy_1DLyTpPvCB93X6ILBBJo/105/image.jpg"
    },
    {
      "id": "ec_0e454af578ef683f58a75814",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-79fc-73b7-8a1d-437455b43dff.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and stainless steel appliances",
        "public_id": "01a03e5c-79fc-73b7-8a1d-437455b43dff",
        "storage_key": "property/6767906449167742/01a03e5c-79fc-73b7-8a1d-437455b43dff.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Spacious modern kitchen featuring a large island with a sink, sleek white cabinetry, and stainless steel appliances, opening up to a balcony.",
      "link": "false",
      "alt_text": "Modern kitchen with island and stainless steel appliances",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/y8R1bMPuZf8VKGbZkMvJMYCvyK0SXJPNzzWVI6nIQRU/119/image.jpg"
    },
    {
      "id": "ec_dd8076994db3af4a9a4304a6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-7d2b-717c-9f91-23f3d044c9a1.webp",
      "image_media": {
        "alt_text": "Modern living room with city view, gray sofa, coffee table, and decorative rug.",
        "public_id": "01a03e5c-7d2b-717c-9f91-23f3d044c9a1",
        "storage_key": "property/6767906449167742/01a03e5c-7d2b-717c-9f91-23f3d044c9a1.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Experience sophisticated urban living in this beautifully appointed apartment, featuring a spacious living area with stunning city vistas.",
      "link": "false",
      "alt_text": "Modern living room with city view, gray sofa, coffee table, and decorative rug.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/2MJDrihOzCsLHKblcYiD51m6zmaS4hoauChlyFQ2lpg/117/image.jpg"
    },
    {
      "id": "ec_1ab0968e5b94f3d278ae3fb5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-903b-704c-81a3-a6d2df8de14f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white countertops, and city views.",
        "public_id": "01a03e5c-903b-704c-81a3-a6d2df8de14f",
        "storage_key": "property/6767906449167742/01a03e5c-903b-704c-81a3-a6d2df8de14f.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Sleek and contemporary kitchen featuring stainless steel appliances, ample counter space, and large windows with stunning city vistas. Perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white countertops, and city views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/s55Cy7p5or3ZFCsNnfUNR3DrfiUxRFLOrheMlUVoYrA/116/image.jpg"
    },
    {
      "id": "ec_1de41c529d31f64ae3499456",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-85c3-731a-97b6-5aefee1da1c3.webp",
      "image_media": {
        "alt_text": "Rooftop lounge with city skyline, bar, grill, fire pit, and seating areas.",
        "public_id": "01a03e5c-85c3-731a-97b6-5aefee1da1c3",
        "storage_key": "property/6767906449167742/01a03e5c-85c3-731a-97b6-5aefee1da1c3.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy breathtaking city views from our rooftop lounge, complete with a full-service bar, outdoor grill, cozy fire pit, and ample seating for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Rooftop lounge with city skyline, bar, grill, fire pit, and seating areas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/lyJRnO-ZvwcX7OSEMMCZpRJpewFy_Y_8zqP-eVGcQoo/102/image.jpg"
    },
    {
      "id": "ec_5fb5b4d08ea6796b458d6703",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-8f8c-755c-83d1-7dd85c35ca76.webp",
      "image_media": {
        "alt_text": "Modern fitness center with cardio machines, weight machines, yoga balls, and resistance bands.",
        "public_id": "01a03e5c-8f8c-755c-83d1-7dd85c35ca76",
        "storage_key": "property/6767906449167742/01a03e5c-8f8c-755c-83d1-7dd85c35ca76.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with a full range of cardio and strength training equipment, plus accessories for a complete workout.",
      "link": "false",
      "alt_text": "Modern fitness center with cardio machines, weight machines, yoga balls, and resistance bands.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/42WosMyuYyD81GaRcDexZ8Q6krR5HIYve_auApO--wg/102/image.jpg"
    },
    {
      "id": "ec_715aba21355775aaae10a87c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-9a5e-736e-9be7-0c1a4ec0c339.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with modern cabanas and city skyline views.",
        "public_id": "01a03e5c-9a5e-736e-9be7-0c1a4ec0c339",
        "storage_key": "property/6767906449167742/01a03e5c-9a5e-736e-9be7-0c1a4ec0c339.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy stunning city views and comfortable seating in our exclusive rooftop lounge, featuring unique cabana-style seating areas.",
      "link": "false",
      "alt_text": "Rooftop lounge area with modern cabanas and city skyline views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/DBOGSfWpSJTb359L49Ao6EJjYIF_3ss0jLEya1lK2MQ/119/image.jpg"
    },
    {
      "id": "ec_ff735e0ed91948274f5f8d23",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-a07b-74eb-8e19-60bf784f6937.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with fire pit and city skyline view at dusk.",
        "public_id": "01a03e5c-a07b-74eb-8e19-60bf784f6937",
        "storage_key": "property/6767906449167742/01a03e5c-a07b-74eb-8e19-60bf784f6937.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy breathtaking city views from our elevated rooftop lounge, complete with a cozy fire pit and comfortable seating. Perfect for relaxing evenings.",
      "link": "false",
      "alt_text": "Rooftop lounge area with fire pit and city skyline view at dusk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/pgZK7JYk2woH-28uB_8x3LJJxhJcRMojjwhbc8T8-Ik/102/image.jpg"
    },
    {
      "id": "ec_c03b450fc3f5cea4ffb73846",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-ac78-74cb-b2dc-6eab9a3e28a7.webp",
      "image_media": {
        "alt_text": "Modern lobby with unique pillar, comfortable seating, and large windows overlooking greenery.",
        "public_id": "01a03e5c-ac78-74cb-b2dc-6eab9a3e28a7",
        "storage_key": "property/6767906449167742/01a03e5c-ac78-74cb-b2dc-6eab9a3e28a7.webp",
        "width": 1478,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our stylish community lobby, featuring contemporary decor, ample seating, and abundant natural light from large windows.",
      "link": "false",
      "alt_text": "Modern lobby with unique pillar, comfortable seating, and large windows overlooking greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/6MPcIjWpoDD0WXLiZ9Muo4H0WEHiKQtNcHEt6TbaFSQ/119/image.jpg"
    },
    {
      "id": "ec_6d3983d37e5f8a9a628ccfe0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-a8d4-73b9-af1b-6d0a26e00d24.webp",
      "image_media": {
        "alt_text": "Elegant community lounge with a long, granite-topped table, modern chairs, and a stylish wet bar.",
        "public_id": "01a03e5c-a8d4-73b9-af1b-6d0a26e00d24",
        "storage_key": "property/6767906449167742/01a03e5c-a8d4-73b9-af1b-6d0a26e00d24.webp",
        "width": 2048,
        "height": 1337
      },
      "title": "Community",
      "description": "Gather in our sophisticated community lounge, featuring a spacious dining area, elegant wet bar, and stunning city views.",
      "link": "false",
      "alt_text": "Elegant community lounge with a long, granite-topped table, modern chairs, and a stylish wet bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/aySMqPevSnRph_tycy--9d0X-VFwgBr58SxGbcKcFx4/102/image.jpg"
    },
    {
      "id": "ec_74c1877c107871978f90ac41",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-b098-72c9-ae7f-1cef4693aa04.webp",
      "image_media": {
        "alt_text": "Luxury living room with large windows, modern furniture, and decorative art.",
        "public_id": "01a03e5c-b098-72c9-ae7f-1cef4693aa04",
        "storage_key": "property/6767906449167742/01a03e5c-b098-72c9-ae7f-1cef4693aa04.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Experience sophisticated living in this beautifully appointed apartment, featuring spacious interiors, elegant decor, and stunning city views.",
      "link": "false",
      "alt_text": "Luxury living room with large windows, modern furniture, and decorative art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/K4TusfrtgwjiDaKzpZ97AWkEhb5kfih0dxy-NV4WJnE/119/image.jpg"
    },
    {
      "id": "ec_7074c3a24bed67bea680d047",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-b769-7287-87b4-fee3a5826191.webp",
      "image_media": {
        "alt_text": "Rooftop deck with bar, grills, seating, and sunset view.",
        "public_id": "01a03e5c-b769-7287-87b4-fee3a5826191",
        "storage_key": "property/6767906449167742/01a03e5c-b769-7287-87b4-fee3a5826191.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy breathtaking sunsets from our rooftop deck, featuring a fully equipped outdoor kitchen and comfortable lounge areas for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Rooftop deck with bar, grills, seating, and sunset view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/-AWIjKtU61QYL0dNXwAo84D7YWU_c8PzEOVsuJwkxF4/102/image.jpg"
    },
    {
      "id": "ec_bb3688117970048b5b1ca566",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-bb31-75d6-839d-5c6eb364ee9d.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with cabanas and pool at a multifamily property.",
        "public_id": "01a03e5c-bb31-75d6-839d-5c6eb364ee9d",
        "storage_key": "property/6767906449167742/01a03e5c-bb31-75d6-839d-5c6eb364ee9d.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling pool in our exclusive outdoor lounge area, featuring comfortable cabanas and ample sun loungers for your enjoyment.",
      "link": "false",
      "alt_text": "Outdoor lounge area with cabanas and pool at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/4N4NL3hKfFo7U58N9fqscC4ig1sn9RWIS5KybxRTQo8/119/image.jpg"
    },
    {
      "id": "ec_819a2ef1894cc8f844e32353",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-c813-7018-b848-a5b111a25280.webp",
      "image_media": {
        "alt_text": "Modern living room with large sectional sofa, coffee tables, and city view at dusk.",
        "public_id": "01a03e5c-c813-7018-b848-a5b111a25280",
        "storage_key": "property/6767906449167742/01a03e5c-c813-7018-b848-a5b111a25280.webp",
        "width": 2048,
        "height": 1303
      },
      "title": "Apartment",
      "description": "Relax in style in this sophisticated living space, featuring plush seating and breathtaking panoramic city views as the sun sets.",
      "link": "false",
      "alt_text": "Modern living room with large sectional sofa, coffee tables, and city view at dusk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/dOeIKphEHPLeEY_vzyPbEAePnSITh_Stk4WjXgfywyw/102/image.jpg"
    },
    {
      "id": "ec_fd3e7efc89ab2a25f4e60393",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-cb9d-705b-9566-260e408528ae.webp",
      "image_media": {
        "alt_text": "Community lounge area with large island, seating, and city views.",
        "public_id": "01a03e5c-cb9d-705b-9566-260e408528ae",
        "storage_key": "property/6767906449167742/01a03e5c-cb9d-705b-9566-260e408528ae.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Luxurious community lounge with a large marble island, comfortable seating, and stunning panoramic city views.",
      "link": "false",
      "alt_text": "Community lounge area with large island, seating, and city views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/G5bG62mzMR66ovOwW1nVzy2oej4zrALPxlTxd9kb0Ag/118/image.jpg"
    },
    {
      "id": "ec_e56cd5b05146fb2523c72756",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-ce18-766e-833e-817ec8003812.webp",
      "image_media": {
        "alt_text": "Modern reception area with unique architectural elements and contemporary art.",
        "public_id": "01a03e5c-ce18-766e-833e-817ec8003812",
        "storage_key": "property/6767906449167742/01a03e5c-ce18-766e-833e-817ec8003812.webp",
        "width": 2048,
        "height": 1391
      },
      "title": "Community",
      "description": "Step into a stylish and welcoming lobby, featuring a striking sculptural reception desk, elegant lighting, and sophisticated artwork. Experience elevated design in our community spaces.",
      "link": "false",
      "alt_text": "Modern reception area with unique architectural elements and contemporary art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/eusvWLn7V_KZZaNxqCxFaxMR3sfhhmfi36ua9cKJans/102/image.jpg"
    },
    {
      "id": "ec_bed8b5004edd6e46bde257d0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-db3a-716a-aec3-d5c95c64900d.webp",
      "image_media": {
        "alt_text": "Modern living room with fireplace and city view",
        "public_id": "01a03e5c-db3a-716a-aec3-d5c95c64900d",
        "storage_key": "property/6767906449167742/01a03e5c-db3a-716a-aec3-d5c95c64900d.webp",
        "width": 2048,
        "height": 1308
      },
      "title": "Apartment",
      "description": "Elegant living room featuring a sleek fireplace, built-in shelving, and panoramic city views at night. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Modern living room with fireplace and city view",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/XSW7dFObLUo-zXTEH5FmdqNtdinookQaXFX5NxkVzgY/115/image.jpg"
    },
    {
      "id": "ec_1e1d08efa649f756c9832560",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-e5cb-725d-8594-803ae0c2a524.webp",
      "image_media": {
        "alt_text": "Modern kitchen with sleek white cabinetry, stainless steel appliances, and a large window with city views.",
        "public_id": "01a03e5c-e5cb-725d-8594-803ae0c2a524",
        "storage_key": "property/6767906449167742/01a03e5c-e5cb-725d-8594-803ae0c2a524.webp",
        "width": 2048,
        "height": 1401
      },
      "title": "Apartment",
      "description": "Experience luxury living in this stunning apartment kitchen, featuring modern finishes and breathtaking city vistas. Perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with sleek white cabinetry, stainless steel appliances, and a large window with city views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/xhNB2W94tltGKury0E08ZL3mNaLlTLl3ed4wsi0wAo0/110/image.jpg"
    },
    {
      "id": "ec_a91e32e8436a885e4238b7a6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-de99-75ce-b0e9-c41724580d95.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry.",
        "public_id": "01a03e5c-de99-75ce-b0e9-c41724580d95",
        "storage_key": "property/6767906449167742/01a03e5c-de99-75ce-b0e9-c41724580d95.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Sleek and modern kitchen featuring stainless steel appliances, glossy white cabinetry, and a dark countertop. Perfect for a stylish living space.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Ad1Dulsw7g8dXLeecQ9TtJZgR7FG5JLus-T2u6TtTYk/119/image.jpg"
    },
    {
      "id": "ec_da8670ebe812b18237e9f0ce",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-e961-770d-8034-7dd64852e089.webp",
      "image_media": {
        "alt_text": "Modern living room with city view, featuring a gray sofa, coffee table, and kitchen island with bar stools.",
        "public_id": "01a03e5c-e961-770d-8034-7dd64852e089",
        "storage_key": "property/6767906449167742/01a03e5c-e961-770d-8034-7dd64852e089.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Experience upscale urban living in this beautifully appointed apartment, complete with a stylish living area, modern kitchen, and breathtaking city skyline views.",
      "link": "false",
      "alt_text": "Modern living room with city view, featuring a gray sofa, coffee table, and kitchen island with bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/RVS_C74l007ZMiTDrfBpsblBrsyM-7gKmDxeqo0SZGQ/104/image.jpg"
    },
    {
      "id": "ec_dbd7cf15106191f6f72f6e56",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-e4c3-75e8-b119-3c6b84e23533.webp",
      "image_media": {
        "alt_text": "King bed with black headboard and white linens, flanked by nightstands with black lamps. Large window with city view.",
        "public_id": "01a03e5c-e4c3-75e8-b119-3c6b84e23533",
        "storage_key": "property/6767906449167742/01a03e5c-e4c3-75e8-b119-3c6b84e23533.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Luxurious king bedroom featuring a stylish black headboard, crisp white linens, and ambient bedside lighting. Enjoy stunning city views from the large window.",
      "link": "false",
      "alt_text": "King bed with black headboard and white linens, flanked by nightstands with black lamps. Large window with city view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/yBwpmvkPNPO60pjk4xopWLV8f7nwhtaiyqFERIFcz-E/115/image.jpg"
    },
    {
      "id": "ec_81bed7811c7231398d7c0652",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-f4a7-710a-9090-bf266de1673d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, large mirror, and bathtub with shower.",
        "public_id": "01a03e5c-f4a7-710a-9090-bf266de1673d",
        "storage_key": "property/6767906449167742/01a03e5c-f4a7-710a-9090-bf266de1673d.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a spacious double vanity with sleek faucets, a large illuminated mirror, and a pristine white bathtub with a stylish shower curtain.",
      "link": "false",
      "alt_text": "Modern bathroom with double vanity, large mirror, and bathtub with shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/tN-VMf87mW3GzJ_5i7QNSrDzhzInFRnVUClj-uypxzA/104/image.jpg"
    },
    {
      "id": "ec_db635bc5a9d7bba9f5b9fbbb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-020f-74df-bf06-520809db6566.webp",
      "image_media": {
        "alt_text": "Bedroom with a large window view of the city, a bed, a dresser, and modern decor.",
        "public_id": "01a03e5d-020f-74df-bf06-520809db6566",
        "storage_key": "property/6767906449167742/01a03e5d-020f-74df-bf06-520809db6566.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable bed, ample storage with a dresser, and a stunning city view from the large window. Perfect for relaxation.",
      "link": "false",
      "alt_text": "Bedroom with a large window view of the city, a bed, a dresser, and modern decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/RNfWRBHDbm6fZubhLRSU0DRaptmfb8MlcVrF1TJ189E/116/image.jpg"
    },
    {
      "id": "ec_1530146ee3ea235210cf7f50",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-b769-7287-87b4-fee3a5826191.webp",
      "image_media": {
        "alt_text": "Rooftop deck with bar, grills, seating, and sunset view.",
        "public_id": "01a03e5c-b769-7287-87b4-fee3a5826191",
        "storage_key": "property/6767906449167742/01a03e5c-b769-7287-87b4-fee3a5826191.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy breathtaking sunsets from our rooftop deck, featuring a fully equipped outdoor kitchen and comfortable lounge areas for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Rooftop deck with bar, grills, seating, and sunset view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/4h8NPPKdN6YmYPyyrQutPOEcXts9N09NAQdfgVHV_ls/116/image.jpg"
    },
    {
      "id": "ec_bc0d066ebf048991cb01ddf9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-0595-73ec-9744-7ec46af4fb07.webp",
      "image_media": {
        "alt_text": "Rooftop swimming pool at sunset with city skyline view.",
        "public_id": "01a03e5d-0595-73ec-9744-7ec46af4fb07",
        "storage_key": "property/6767906449167742/01a03e5d-0595-73ec-9744-7ec46af4fb07.webp",
        "width": 2048,
        "height": 1362
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning rooftop pool, perfect for unwinding while taking in breathtaking sunset views of the city skyline.",
      "link": "false",
      "alt_text": "Rooftop swimming pool at sunset with city skyline view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/SgXPjwLbURXqgX9xeO_qWRjGX6RXY3XQArCopCkh0SU/115/image.jpg"
    },
    {
      "id": "ec_ead2c14e58ee7ede25416fb1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-0656-765c-b7d0-ccdce475600a.webp",
      "image_media": {
        "alt_text": "Modern living room with a fireplace, large windows, and city views at night.",
        "public_id": "01a03e5d-0656-765c-b7d0-ccdce475600a",
        "storage_key": "property/6767906449167742/01a03e5d-0656-765c-b7d0-ccdce475600a.webp",
        "width": 640,
        "height": 480
      },
      "title": "Apartment",
      "description": "Experience luxury living in this modern apartment. Features include a sleek fireplace, expansive windows showcasing cityscapes, and stylish furnishings. Perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "Modern living room with a fireplace, large windows, and city views at night.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/k5yTHuEU0h196kKv3ijY2BQDY2U829yqeI_EFQvJrug/102/image.jpg"
    },
    {
      "id": "ec_3699bbbc79ca424ff8d7e194",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-0d56-760d-8e01-f7d9e6bbee17.webp",
      "image_media": {
        "alt_text": "Ascent apartment building exterior with city lights at dusk.",
        "public_id": "01a03e5d-0d56-760d-8e01-f7d9e6bbee17",
        "storage_key": "property/6767906449167742/01a03e5d-0d56-760d-8e01-f7d9e6bbee17.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Ascent apartment building exterior with illuminated signage, balconies, and large windows, set against a twilight cityscape.",
      "link": "false",
      "alt_text": "Ascent apartment building exterior with city lights at dusk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Mi_EndE1ifbbbfqZkBmPGIsvzEHlrnYC6Zc61QSlM8k/116/image.jpg"
    },
    {
      "id": "ec_dad59c628e992608c1e1c434",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-0b52-719e-93f6-af640c540cf1.webp",
      "image_media": {
        "alt_text": "Rooftop lounge with city skyline view at dusk",
        "public_id": "01a03e5d-0b52-719e-93f6-af640c540cf1",
        "storage_key": "property/6767906449167742/01a03e5d-0b52-719e-93f6-af640c540cf1.webp",
        "width": 640,
        "height": 480
      },
      "title": "Community",
      "description": "Enjoy stunning city views from the rooftop lounge, featuring comfortable seating, fire pits, and outdoor grills. An ideal space for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Rooftop lounge with city skyline view at dusk",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/JaBC2eOu59w9gxMWmR7Lbr87JyLSTKDZ0Szk7EvJLuE/114/image.jpg"
    },
    {
      "id": "ec_a5c3be06fa37512ccc2690ca",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-bb31-75d6-839d-5c6eb364ee9d.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with cabanas and pool at a multifamily property.",
        "public_id": "01a03e5c-bb31-75d6-839d-5c6eb364ee9d",
        "storage_key": "property/6767906449167742/01a03e5c-bb31-75d6-839d-5c6eb364ee9d.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling pool in our exclusive outdoor lounge area, featuring comfortable cabanas and ample sun loungers for your enjoyment.",
      "link": "false",
      "alt_text": "Outdoor lounge area with cabanas and pool at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/TwZnEdpPqZmsmqPcCgPZpQ2nL-SYHVtbvGcCSYG02sQ/116/image.jpg"
    },
    {
      "id": "ec_9898e632ef73b9a2aafd9983",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-17d8-77cf-8915-dff43916f2be.webp",
      "image_media": {
        "alt_text": "Rooftop pool area with bar, seating, and tables.",
        "public_id": "01a03e5d-17d8-77cf-8915-dff43916f2be",
        "storage_key": "property/6767906449167742/01a03e5d-17d8-77cf-8915-dff43916f2be.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy our stunning rooftop pool area, complete with a full-service bar, comfortable seating, and spacious tables, perfect for socializing and relaxing.",
      "link": "false",
      "alt_text": "Rooftop pool area with bar, seating, and tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/pbV2HP6ga-78I06Oh0wOmJ0zGEViB3qR0XPtoV1Rvbg/115/image.jpg"
    },
    {
      "id": "ec_8ad18613613cac245cbe6a79",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-1c18-778d-aa3c-f4b2332b2e6a.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with cardio machines and weight equipment, large windows with city views.",
        "public_id": "01a03e5d-1c18-778d-aa3c-f4b2332b2e6a",
        "storage_key": "property/6767906449167742/01a03e5d-1c18-778d-aa3c-f4b2332b2e6a.webp",
        "width": 640,
        "height": 480
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of cardio machines, weightlifting equipment, and yoga space, all with stunning city views.",
      "link": "false",
      "alt_text": "Modern apartment gym with cardio machines and weight equipment, large windows with city views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/92kaSHstTr8fANdeHLavq_za-az9w_5wLCyoYLkS2Pk/112/image.jpg"
    },
    {
      "id": "ec_67b315375d72822de1fe1c4d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-1e92-7188-8af6-19564ca4df8b.webp",
      "image_media": {
        "alt_text": "Modern fitness center with weight machines, cardio equipment, and a boxing bag.",
        "public_id": "01a03e5d-1e92-7188-8af6-19564ca4df8b",
        "storage_key": "property/6767906449167742/01a03e5d-1e92-7188-8af6-19564ca4df8b.webp",
        "width": 2048,
        "height": 1558
      },
      "title": "Community",
      "description": "Experience our state-of-the-art fitness center, equipped with everything you need for a complete workout. Enjoy a variety of weight machines, cardio equipment, and a dedicated space for functional training.",
      "link": "false",
      "alt_text": "Modern fitness center with weight machines, cardio equipment, and a boxing bag.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/H-BOUCZxZN-XgOSNLXbnm_EmENS0NJnteEyLHCSgenk/119/image.jpg"
    },
    {
      "id": "ec_06220c1f7c45a2bd79c52c06",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-c813-7018-b848-a5b111a25280.webp",
      "image_media": {
        "alt_text": "Modern living room with large sectional sofa, coffee tables, and city view at dusk.",
        "public_id": "01a03e5c-c813-7018-b848-a5b111a25280",
        "storage_key": "property/6767906449167742/01a03e5c-c813-7018-b848-a5b111a25280.webp",
        "width": 2048,
        "height": 1303
      },
      "title": "Apartment",
      "description": "Relax in style in this sophisticated living space, featuring plush seating and breathtaking panoramic city views as the sun sets.",
      "link": "false",
      "alt_text": "Modern living room with large sectional sofa, coffee tables, and city view at dusk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/yiogyxZ9_Q3AoVvX0ArkH0Cu6DZgMlP-z__Gx5miaf8/112/image.jpg"
    },
    {
      "id": "ec_f49ff2ac1908a2b725a23328",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-a8d4-73b9-af1b-6d0a26e00d24.webp",
      "image_media": {
        "alt_text": "Elegant community lounge with a long, granite-topped table, modern chairs, and a stylish wet bar.",
        "public_id": "01a03e5c-a8d4-73b9-af1b-6d0a26e00d24",
        "storage_key": "property/6767906449167742/01a03e5c-a8d4-73b9-af1b-6d0a26e00d24.webp",
        "width": 2048,
        "height": 1337
      },
      "title": "Community",
      "description": "Gather in our sophisticated community lounge, featuring a spacious dining area, elegant wet bar, and stunning city views.",
      "link": "false",
      "alt_text": "Elegant community lounge with a long, granite-topped table, modern chairs, and a stylish wet bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/boe24bQrg8ZpZar4oNHgODw3ZBtcm2sY0VNFPkScBrU/119/image.jpg"
    },
    {
      "id": "ec_c4e7e775f3a46b6c8f1dece6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-cb9d-705b-9566-260e408528ae.webp",
      "image_media": {
        "alt_text": "Community lounge area with large island, seating, and city views.",
        "public_id": "01a03e5c-cb9d-705b-9566-260e408528ae",
        "storage_key": "property/6767906449167742/01a03e5c-cb9d-705b-9566-260e408528ae.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Luxurious community lounge with a large marble island, comfortable seating, and stunning panoramic city views.",
      "link": "false",
      "alt_text": "Community lounge area with large island, seating, and city views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/jWhzSlzhz_NzkdejRfY6PF6739eXdrjq7XFbT4YRgo0/111/image.jpg"
    },
    {
      "id": "ec_c07eb62888772e5f2cfb49e4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-341e-705d-a959-101aebca976e.webp",
      "image_media": {
        "alt_text": "Modern community lounge area with fireplace and bar seating.",
        "public_id": "01a03e5d-341e-705d-a959-101aebca976e",
        "storage_key": "property/6767906449167742/01a03e5d-341e-705d-a959-101aebca976e.webp",
        "width": 2048,
        "height": 1325
      },
      "title": "Community",
      "description": "Relax and socialize in our sophisticated community lounge, featuring a sleek fireplace, comfortable seating, and a stylish bar area.",
      "link": "false",
      "alt_text": "Modern community lounge area with fireplace and bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/E3sKupeqZnpF9JJqDuCuldJoP8SsPMYNx4KlOVvoIxk/119/image.jpg"
    },
    {
      "id": "ec_0c99245ac40f6cd9c7683bdd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-381e-7279-b4d2-18735387be32.webp",
      "image_media": {
        "alt_text": "Night view of a city skyline with illuminated skyscrapers and a highway.",
        "public_id": "01a03e5d-381e-7279-b4d2-18735387be32",
        "storage_key": "property/6767906449167742/01a03e5d-381e-7279-b4d2-18735387be32.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Experience the vibrant city life from our community, offering stunning night views of the illuminated skyline and convenient access to major roadways.",
      "link": "false",
      "alt_text": "Night view of a city skyline with illuminated skyscrapers and a highway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/NnYnSInyJ5tM9A_Pu9EA_iwvbDWzZjgQsVFEqCkaP84/116/image.jpg"
    },
    {
      "id": "ec_40a4c22333e9c18204f0fef9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-39d0-7638-be77-fb99a90dda49.webp",
      "image_media": {
        "alt_text": "Lake and city skyline with trees and reflections",
        "public_id": "01a03e5d-39d0-7638-be77-fb99a90dda49",
        "storage_key": "property/6767906449167742/01a03e5d-39d0-7638-be77-fb99a90dda49.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "A scenic view of a city skyline reflected in a calm lake, surrounded by lush green trees.",
      "link": "false",
      "alt_text": "Lake and city skyline with trees and reflections",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/YPlP6tbCy8JTX94kfAIdGnjup0WCTwcWX-9tzOHgB20/114/image.jpg"
    },
    {
      "id": "ec_554f387c4f82794289171ab7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-574c-735e-8c6f-04c894347f91.webp",
      "image_media": {
        "alt_text": "A couple smiles at a barista behind a coffee machine.",
        "public_id": "01a03e5d-574c-735e-8c6f-04c894347f91",
        "storage_key": "property/6767906449167742/01a03e5d-574c-735e-8c6f-04c894347f91.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Lifestyle",
      "description": "A couple enjoys a moment at a local coffee shop, served by a friendly barista.",
      "link": "false",
      "alt_text": "A couple smiles at a barista behind a coffee machine.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/TWeO8xE7oF9fY_0VL2A1-C7Bu4-6P2iin_3vHqCXNR8/115/image.jpg"
    },
    {
      "id": "ec_2b3aac39ba33383d8ef3a567",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-3910-730e-8a6c-8ba113022b33.webp",
      "image_media": {
        "alt_text": "Musicians in an orchestra reading sheet music.",
        "public_id": "01a03e5d-3910-730e-8a6c-8ba113022b33",
        "storage_key": "property/6767906449167742/01a03e5d-3910-730e-8a6c-8ba113022b33.webp",
        "width": 1024,
        "height": 682
      },
      "title": "Other",
      "description": "A group of musicians in an orchestra are seen from behind, illuminated by music stand lights as they read their sheet music.",
      "link": "false",
      "alt_text": "Musicians in an orchestra reading sheet music.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/uc-aitHI47W1g4TAOqgMgP7Te95IjhU0tw_IRcjsEoM/114/image.jpg"
    },
    {
      "id": "ec_d483297c4973fe2f93b46c7e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-4a22-7261-87c9-359b7c2b8a7e.webp",
      "image_media": {
        "alt_text": "A group of friends enjoying dinner and drinks",
        "public_id": "01a03e5d-4a22-7261-87c9-359b7c2b8a7e",
        "storage_key": "property/6767906449167742/01a03e5d-4a22-7261-87c9-359b7c2b8a7e.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Lifestyle",
      "description": "Experience the vibrant social scene at our community, where residents gather for memorable dining experiences.",
      "link": "false",
      "alt_text": "A group of friends enjoying dinner and drinks",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/3RjUDLeyzkRlrQQrtCnMfdHYXHajPUwivsMeezElVHw/119/image.jpg"
    },
    {
      "id": "ec_2aeadec9cccca21d69be2afb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-5b1c-758f-9ca3-9a7ea1e59c0e.webp",
      "image_media": {
        "alt_text": "Fireworks display over a stadium at night, viewed from a nearby apartment building.",
        "public_id": "01a03e5d-5b1c-758f-9ca3-9a7ea1e59c0e",
        "storage_key": "property/6767906449167742/01a03e5d-5b1c-758f-9ca3-9a7ea1e59c0e.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Experience the excitement of the city with a front-row seat to spectacular fireworks displays, viewed from the comfort of your home.",
      "link": "false",
      "alt_text": "Fireworks display over a stadium at night, viewed from a nearby apartment building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/k0UIDNOA1XemVRIwVSdDjGRKas5Fl0al90SY-R5CqE4/114/image.jpg"
    },
    {
      "id": "ec_3d22b387bbbbaef0ff922d74",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-5acd-71f9-9039-0040359ba6af.webp",
      "image_media": {
        "alt_text": "Downtown Atlanta skyline at night with glowing skyscrapers and busy highways.",
        "public_id": "01a03e5d-5acd-71f9-9039-0040359ba6af",
        "storage_key": "property/6767906449167742/01a03e5d-5acd-71f9-9039-0040359ba6af.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Experience the vibrant energy of downtown Atlanta from your doorstep. Enjoy stunning city views and easy access to the best dining, entertainment, and business districts.",
      "link": "false",
      "alt_text": "Downtown Atlanta skyline at night with glowing skyscrapers and busy highways.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/mxVg14WeK5FmpYYQ6cZ_8S_HEL4lDoUa9FNxYMamEys/115/image.jpg"
    },
    {
      "id": "ec_6f0a9a5ddf5d731b1ff2730b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-381e-7279-b4d2-18735387be32.webp",
      "image_media": {
        "alt_text": "Night view of a city skyline with illuminated skyscrapers and a highway.",
        "public_id": "01a03e5d-381e-7279-b4d2-18735387be32",
        "storage_key": "property/6767906449167742/01a03e5d-381e-7279-b4d2-18735387be32.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Experience the vibrant city life from our community, offering stunning night views of the illuminated skyline and convenient access to major roadways.",
      "link": "false",
      "alt_text": "Night view of a city skyline with illuminated skyscrapers and a highway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/hxhj9zsneHuAxsSKNK0GxYBi7uRVyRKw5ySrUI-wYDE/114/image.jpg"
    },
    {
      "id": "ec_8db8f26db03f92c5ae70a1fb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-5d5d-769d-8777-a0f9b111c0a0.webp",
      "image_media": {
        "alt_text": "Modern white building with glass accents and a large \"GO WEST!\" banner on the side.",
        "public_id": "01a03e5d-5d5d-769d-8777-a0f9b111c0a0",
        "storage_key": "property/6767906449167742/01a03e5d-5d5d-769d-8777-a0f9b111c0a0.webp",
        "width": 870,
        "height": 580
      },
      "title": "Community",
      "description": "Explore the striking modern architecture of our community, featuring clean lines and elegant design. An exterior view showcases the building's facade and a vibrant banner.",
      "link": "false",
      "alt_text": "Modern white building with glass accents and a large \"GO WEST!\" banner on the side.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/M0Mq5TiqiRSAz0lQ8t12Z-xizyuIc2r7BSnBjKMKXOo/115/image.jpg"
    },
    {
      "id": "ec_b75a6c8ef9f180d022e143ea",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-5f51-7648-881d-1c82cad4f512.webp",
      "image_media": {
        "alt_text": "Colorful monument sign spelling 'Midtown'",
        "public_id": "01a03e5d-5f51-7648-881d-1c82cad4f512",
        "storage_key": "property/6767906449167742/01a03e5d-5f51-7648-881d-1c82cad4f512.webp",
        "width": 1200,
        "height": 628
      },
      "title": "Community",
      "description": "A vibrant, multi-colored monument sign spelling 'Midtown' is a prominent feature in the urban landscape, surrounded by modern buildings and lush trees.",
      "link": "false",
      "alt_text": "Colorful monument sign spelling 'Midtown'",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/xnlEOvPFfuN_qyLF06fFQjwLXB8K8RmXI_R6yMU90M4/114/image.jpg"
    },
    {
      "id": "ec_30b745483d121125a19e18d7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-70e7-70dc-8e9e-c15b6c31808e.webp",
      "image_media": {
        "alt_text": "Skyline view of a city at dusk with illuminated buildings and trees.",
        "public_id": "01a03e5d-70e7-70dc-8e9e-c15b6c31808e",
        "storage_key": "property/6767906449167742/01a03e5d-70e7-70dc-8e9e-c15b6c31808e.webp",
        "width": 1731,
        "height": 1155
      },
      "title": "Community",
      "description": "Experience the vibrant city life from our community, offering stunning skyline views and a prime location.",
      "link": "false",
      "alt_text": "Skyline view of a city at dusk with illuminated buildings and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/dk5MYGgGtMmztXX6mQZKyT2ZrMFQgYrMcfNVV0tEX68/115/image.jpg"
    },
    {
      "id": "ec_546479d3abba3439ff2e7390",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-73fd-703e-8ce4-a0e04a59bb97.webp",
      "image_media": {
        "alt_text": "Cityscape at dusk with a highway in the foreground and illuminated buildings and stadium in the background.",
        "public_id": "01a03e5d-73fd-703e-8ce4-a0e04a59bb97",
        "storage_key": "property/6767906449167742/01a03e5d-73fd-703e-8ce4-a0e04a59bb97.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Experience the vibrant energy of the city from your doorstep. This stunning cityscape captures the dynamic urban environment, offering a perfect backdrop for your new home.",
      "link": "false",
      "alt_text": "Cityscape at dusk with a highway in the foreground and illuminated buildings and stadium in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/UDj4emcptbf2tOIC3ygoQhhWCVcq8eiVVbAk7b9gjwc/114/image.jpg"
    },
    {
      "id": "ec_17ea3801d1fb895262a404e0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-72fd-733f-bcc9-a17e3136615a.webp",
      "image_media": {
        "alt_text": "View of a serene lake with a city skyline and lush greenery in the background.",
        "public_id": "01a03e5d-72fd-733f-bcc9-a17e3136615a",
        "storage_key": "property/6767906449167742/01a03e5d-72fd-733f-bcc9-a17e3136615a.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy the tranquility of the lake with a stunning city skyline backdrop. The community offers beautiful views and a peaceful atmosphere.",
      "link": "false",
      "alt_text": "View of a serene lake with a city skyline and lush greenery in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/cPY8L0zjyC3h9u4WVAxki4t4lCicTzA0yfRI-qQ_Gns/119/image.jpg"
    },
    {
      "id": "ec_3454db7ffd41f27c54d9bda6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-7c8d-7481-b3f8-d71c8a4dccc9.webp",
      "image_media": {
        "alt_text": "Modern bathroom with sliding barn door and vanity",
        "public_id": "01a03e5d-7c8d-7481-b3f8-d71c8a4dccc9",
        "storage_key": "property/6767906449167742/01a03e5d-7c8d-7481-b3f8-d71c8a4dccc9.webp",
        "width": 2048,
        "height": 1171
      },
      "title": "Apartment",
      "description": "Step into a modern oasis with this stylish bathroom featuring a sleek vanity and a unique sliding barn door.",
      "link": "false",
      "alt_text": "Modern bathroom with sliding barn door and vanity",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/pzEHt60xr6IAXIORs1fg0sCGJyPoxuAz-kv25OnUmpw/114/image.jpg"
    },
    {
      "id": "ec_42e06db53b304c6cc3c0383e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-79e4-75cc-b058-8e5c80d758bf.webp",
      "image_media": {
        "alt_text": "Modern apartment building lobby with abstract art, wood accents, and a marble front desk.",
        "public_id": "01a03e5d-79e4-75cc-b058-8e5c80d758bf",
        "storage_key": "property/6767906449167742/01a03e5d-79e4-75cc-b058-8e5c80d758bf.webp",
        "width": 2048,
        "height": 1171
      },
      "title": "Community",
      "description": "Experience luxury living in our stunning apartment lobby, featuring a contemporary design with abstract art, warm wood finishes, and a sleek marble reception desk.",
      "link": "false",
      "alt_text": "Modern apartment building lobby with abstract art, wood accents, and a marble front desk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/uJS3sgFnBSIsn3acPg--sN_-QbWjn5e_5U_XGRsnOrc/119/image.jpg"
    },
    {
      "id": "ec_8b55c07a40f72fc096167977",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-8fb1-722d-afc3-9c3d7546eda2.webp",
      "image_media": {
        "alt_text": "Modern apartment bedroom with a king-sized bed, desk, and city view.",
        "public_id": "01a03e5d-8fb1-722d-afc3-9c3d7546eda2",
        "storage_key": "property/6767906449167742/01a03e5d-8fb1-722d-afc3-9c3d7546eda2.webp",
        "width": 2048,
        "height": 1171
      },
      "title": "Apartment",
      "description": "Stylish and modern apartment bedroom featuring a comfortable king-sized bed, a functional workspace, and a large window with a city view. Perfect for comfortable urban living.",
      "link": "false",
      "alt_text": "Modern apartment bedroom with a king-sized bed, desk, and city view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/26r3jl99ff4Uv-s4GNGt35xHvh-wvJ6fx6sWQDsWTQY/114/image.jpg"
    },
    {
      "id": "ec_e86aef32bbbf64a1981eec66",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-9016-73ce-824f-af929bf76b03.webp",
      "image_media": {
        "alt_text": "Modern lounge area with communal tables, seating, and decorative lighting.",
        "public_id": "01a03e5d-9016-73ce-824f-af929bf76b03",
        "storage_key": "property/6767906449167742/01a03e5d-9016-73ce-824f-af929bf76b03.webp",
        "width": 2048,
        "height": 1171
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring comfortable seating and a modern aesthetic perfect for work or leisure.",
      "link": "false",
      "alt_text": "Modern lounge area with communal tables, seating, and decorative lighting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/kduV8-eY-vuwXeDTrbe_iWvIdEb-_uqSNGo0kCEwQcg/119/image.jpg"
    },
    {
      "id": "ec_713852005474a93e00e25ac8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5d-9dc6-7639-a5e5-bab127f15e3e.webp",
      "image_media": {
        "alt_text": "Modern coffee bar and lounge area with comfortable seating.",
        "public_id": "01a03e5d-9dc6-7639-a5e5-bab127f15e3e",
        "storage_key": "property/6767906449167742/01a03e5d-9dc6-7639-a5e5-bab127f15e3e.webp",
        "width": 2048,
        "height": 1171
      },
      "title": "Community",
      "description": "Enjoy a relaxing atmosphere in our stylish coffee bar and lounge, perfect for socializing or unwinding.",
      "link": "false",
      "alt_text": "Modern coffee bar and lounge area with comfortable seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/vMAbV2MOgqrAx6VlLL_ZRjPEwlwjfe9Te-ZY-dqzYfg/114/image.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_07dee719e608eb72ab51bd13",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "South City Kitchen Midtown",
      "poi_type": "Restaurants",
      "poi_address": "1144 Crescent Ave NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Inventive takes on Southern classics, including a popular brunch, served in upscale surroundings.",
      "poi_long_description": "Inventive takes on Southern classics, including a popular brunch, served in upscale surroundings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-c5a0-7056-9301-9397eb2c9369.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-c5a0-7056-9301-9397eb2c9369",
        "storage_key": "property/6767906449167742/01a03e5b-c5a0-7056-9301-9397eb2c9369.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.southcitykitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11724931360973815545&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-city-kitchen-midtown",
      "poi_latitude": "33.7859545",
      "poi_longitude": "-84.3844341",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-873-7358",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9746-7471-b9aa-6ee0a915decf",
        "storage_key": "property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvQqtX0ME9YgR-X6ukvNSt6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_23423853338afed611c32adb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Café Intermezzo - Midtown",
      "poi_type": "Restaurants",
      "poi_address": "1065 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "European-style coffeehouse offering many beverages & pastries, plus crêpes & sandwiches.",
      "poi_long_description": "European-style coffeehouse offering many beverages & pastries, plus crêpes & sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-b2e9-72c8-ab5d-766bd77a8b1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-b2e9-72c8-ab5d-766bd77a8b1b",
        "storage_key": "property/6767906449167742/01a03e5b-b2e9-72c8-ab5d-766bd77a8b1b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.cafeintermezzo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2132681066176294857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caf-intermezzo---midtown",
      "poi_latitude": "33.7832371",
      "poi_longitude": "-84.3836022",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-355-0411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-a7d1-708c-9901-e34533495ae5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a7d1-708c-9901-e34533495ae5",
        "storage_key": "property/6767906449167742/01a03e5c-a7d1-708c-9901-e34533495ae5.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJicBn_aoF9YgRya-jWCHOmB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_b36131e44f63caf6f07fcfad",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "The Vortex Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "878 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Local fixture known for its burgers, beer & whiskey selection & offbeat, rock 'n' roll vibe.",
      "poi_long_description": "Local fixture known for its burgers, beer & whiskey selection & offbeat, rock 'n' roll vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-b789-7149-9ca8-c1ba13cd76d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-b789-7149-9ca8-c1ba13cd76d5",
        "storage_key": "property/6767906449167742/01a03e5b-b789-7149-9ca8-c1ba13cd76d5.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.thevortexbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2105728285314260711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-vortex-bar--grill",
      "poi_latitude": "33.7790602",
      "poi_longitude": "-84.3844407",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-875-1667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9746-7471-b9aa-6ee0a915decf",
        "storage_key": "property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-icamgE9YgR5x6mB7gMOR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_db14d658bac3dec5806fa093",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Ecco Midtown",
      "poi_type": "Restaurants",
      "poi_address": "40 7th St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Sleek spot for an ever-changing menu of seasonally inspired Continental fare & a bustling bar scene.",
      "poi_long_description": "Sleek spot for an ever-changing menu of seasonally inspired Continental fare & a bustling bar scene.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-bab4-766b-9295-8ae3131c30d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-bab4-766b-9295-8ae3131c30d7",
        "storage_key": "property/6767906449167742/01a03e5b-bab4-766b-9295-8ae3131c30d7.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://www.ecco-atlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1615100838986662872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ecco-midtown",
      "poi_latitude": "33.7787559",
      "poi_longitude": "-84.38584410000001",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-347-9555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9746-7471-b9aa-6ee0a915decf",
        "storage_key": "property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlyVS2WcE9YgR2EM86Kf9aRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_4b3628a45257e6070d49b9c4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Lyla Lila",
      "poi_type": "Restaurants",
      "poi_address": "693 Peachtree St NE Unit 118, Atlanta, GA 30308, USA",
      "poi_short_description": "Upscale restaurant with a trendy vibe serving up southern European fare, including pasta & seafood.",
      "poi_long_description": "Upscale restaurant with a trendy vibe serving up southern European fare, including pasta & seafood.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-c08c-70a0-8129-2b89bf34d9c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-c08c-70a0-8129-2b89bf34d9c7",
        "storage_key": "property/6767906449167742/01a03e5b-c08c-70a0-8129-2b89bf34d9c7.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.lylalilaatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13933689576621309154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lyla-lila",
      "poi_latitude": "33.7735507",
      "poi_longitude": "-84.3846361",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-963-2637",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9746-7471-b9aa-6ee0a915decf",
        "storage_key": "property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz_3PrTsF9YgR4nwTmdhoXsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_6e218d38eb2eb8cc5d5ca36d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "PONKO Chicken Midtown",
      "poi_type": "Restaurants",
      "poi_address": "915 W Peachtree St NW Ste 6, Atlanta, GA 30309, USA",
      "poi_short_description": "Casual chain eatery with an Asian-American menu, offering chicken tenders, tacos and plates.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-bc4f-70cd-a546-f58c2b6b8e64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-bc4f-70cd-a546-f58c2b6b8e64",
        "storage_key": "property/6767906449167742/01a03e5b-bc4f-70cd-a546-f58c2b6b8e64.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ponkochicken.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4808021723872782793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ponko-chicken-midtown",
      "poi_latitude": "33.7800547",
      "poi_longitude": "-84.38706909999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-975-2316",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9746-7471-b9aa-6ee0a915decf",
        "storage_key": "property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKQRsaD4F9YgRyWnMq0iGuUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_056f976bbaf73ee656c08b4b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Rowdy Tiger Whiskey Bar & Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "866 W Peachtree St NW, Atlanta, GA 30308, USA",
      "poi_short_description": "Southern-style dishes & whiskey-based cocktails at a retro-chic joint with a rooftop terrace.",
      "poi_long_description": "Southern-style dishes & whiskey-based cocktails at a retro-chic joint with a rooftop terrace.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-b192-706a-8157-45faf23d696d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-b192-706a-8157-45faf23d696d",
        "storage_key": "property/6767906449167742/01a03e5b-b192-706a-8157-45faf23d696d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.rowdytigeratlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3452630097654964447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rowdy-tiger-whiskey-bar--kitchen",
      "poi_latitude": "33.7781729",
      "poi_longitude": "-84.38752389999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-412-2402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9746-7471-b9aa-6ee0a915decf",
        "storage_key": "property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrdmMaAUF9YgR3-CL78c06i8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_f792ab7aba2fc0a424a15bb3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Cypress Street Pint & Plate",
      "poi_type": "Restaurants",
      "poi_address": "817 W Peachtree St NW a180, Atlanta, GA 30308, USA",
      "poi_short_description": "A rotating lineup of beers on tap pairs with hearty American grub at a relaxed tavern with a patio.",
      "poi_long_description": "A rotating lineup of beers on tap pairs with hearty American grub at a relaxed tavern with a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-bcf7-7208-b431-87011137607d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-bcf7-7208-b431-87011137607d",
        "storage_key": "property/6767906449167742/01a03e5b-bcf7-7208-b431-87011137607d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://cypressatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5004059078031367358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cypress-street-pint--plate",
      "poi_latitude": "33.7773253",
      "poi_longitude": "-84.38614559999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-815-9243",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-a7d6-7103-8bc5-5feceb18d381.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a7d6-7103-8bc5-5feceb18d381",
        "storage_key": "property/6767906449167742/01a03e5c-a7d6-7103-8bc5-5feceb18d381.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJweczQWYE9YgRvtwgBTj9cUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_04ada72113bbb60cd292fdf1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "The Flying Biscuit Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1001 Piedmont Ave NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Branch of a laid-back chain known for Southern food & all-day breakfast selections.",
      "poi_long_description": "Branch of a laid-back chain known for Southern food & all-day breakfast selections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-bca7-7359-a4d9-2933916a22ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-bca7-7359-a4d9-2933916a22ac",
        "storage_key": "property/6767906449167742/01a03e5b-bca7-7359-a4d9-2933916a22ac.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://flyingbiscuit.com/locations-2/midtown/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12788756931156114426&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-flying-biscuit-cafe",
      "poi_latitude": "33.7819124",
      "poi_longitude": "-84.38027520000001",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-874-8887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9746-7471-b9aa-6ee0a915decf",
        "storage_key": "property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvewei0EE9YgR-vtf0KvKerE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_75bb085a4834702b37f5a54b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Campagnolo Restaurant + Bar",
      "poi_type": "Restaurants",
      "poi_address": "980 Piedmont Ave NE, Atlanta, GA 30309, USA",
      "poi_short_description": "This modern space with rustic accents & a patio offers a seasonal Italian menu of pastas & mains.",
      "poi_long_description": "This modern space with rustic accents & a patio offers a seasonal Italian menu of pastas & mains.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-b656-7612-980d-f48be2f0f31d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-b656-7612-980d-f48be2f0f31d",
        "storage_key": "property/6767906449167742/01a03e5b-b656-7612-980d-f48be2f0f31d.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "http://www.campagnoloatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17411424561397993574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "campagnolo-restaurant--bar",
      "poi_latitude": "33.7813828",
      "poi_longitude": "-84.3809028",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-343-2446",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9746-7471-b9aa-6ee0a915decf",
        "storage_key": "property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJowF0G0IE9YgRZpCjj2POofE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_0bf3b4eada7d70cc08b5adaa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Blake's On The Park",
      "poi_type": "Restaurants",
      "poi_address": "227 10th St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Straight-friendly gay bar & neighborhood hangout with karaoke, live DJs & drag shows since 1988.",
      "poi_long_description": "Straight-friendly gay bar & neighborhood hangout with karaoke, live DJs & drag shows since 1988.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-d611-7352-bbb0-d4b52624579a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-d611-7352-bbb0-d4b52624579a",
        "storage_key": "property/6767906449167742/01a03e5b-d611-7352-bbb0-d4b52624579a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://blakesontheparkatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10302959985543914892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blakes-on-the-park",
      "poi_latitude": "33.7816462",
      "poi_longitude": "-84.3798958",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-464-7715",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-a7d6-7103-8bc5-5feceb18d381.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a7d6-7103-8bc5-5feceb18d381",
        "storage_key": "property/6767906449167742/01a03e5c-a7d6-7103-8bc5-5feceb18d381.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdZ5ktD8E9YgRjKVo-YR3-44",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_e433b4c8aa81bf295e234732",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Ray's New York Pizza",
      "poi_type": "Restaurants",
      "poi_address": "26 5th St NW, Atlanta, GA 30332, USA",
      "poi_short_description": "Branch of chain pizzeria also offers sandwiches & pastas plus Mediterranean fare & upstairs seating.",
      "poi_long_description": "Branch of chain pizzeria also offers sandwiches & pastas plus Mediterranean fare & upstairs seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-d794-745d-b62c-6de8cfd0241d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-d794-745d-b62c-6de8cfd0241d",
        "storage_key": "property/6767906449167742/01a03e5b-d794-745d-b62c-6de8cfd0241d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.raysnewyorkpizza.com/?utm_source=google&utm_medium=wix_google_business_profile&utm_campaign=15318366614929564075",
      "poi_directions_map_url": "https://maps.google.com/?cid=9135719434802151797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rays-new-york-pizza",
      "poi_latitude": "33.7766683",
      "poi_longitude": "-84.3882138",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-888-9911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9746-7471-b9aa-6ee0a915decf",
        "storage_key": "property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz0OaXmYE9YgRdcEDP2yYyH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_4e985ee5c387d15b15ad7775",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Tin Drum Asian Kitchen & Boba Tea Bar - Georgia Tech",
      "poi_type": "Restaurants",
      "poi_address": "88 5th St NW, Atlanta, GA 30308, USA",
      "poi_short_description": "Hip cafe chain serving Pan-Asian fare, such as Indian curries & Chinese noodles.",
      "poi_long_description": "Hip cafe chain serving Pan-Asian fare, such as Indian curries & Chinese noodles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-d334-71ef-95ad-54f4d38e8175.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-d334-71ef-95ad-54f4d38e8175",
        "storage_key": "property/6767906449167742/01a03e5b-d334-71ef-95ad-54f4d38e8175.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tindrumasiankitchen.com/georgia-tech-atlanta-ga",
      "poi_directions_map_url": "https://maps.google.com/?cid=12273254479326605378&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tin-drum-asian-kitchen--boba-tea-bar---georgia-tech",
      "poi_latitude": "33.7766331",
      "poi_longitude": "-84.39004670000001",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-881-1368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9746-7471-b9aa-6ee0a915decf",
        "storage_key": "property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpVnUxmYE9YgRQvA7JuxbU6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_eeadae109be85cb9ab3d3708",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Politan Row at Colony Square",
      "poi_type": "Restaurants",
      "poi_address": "1197 Peachtree St NE Apt 150, Atlanta, GA 30361, USA",
      "poi_short_description": "A casual food hall with vendors serving pizza, banh mi, ramen and tacos, plus two bars.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-e460-733c-a334-702c84ecf7e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-e460-733c-a334-702c84ecf7e6",
        "storage_key": "property/6767906449167742/01a03e5b-e460-733c-a334-702c84ecf7e6.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://colonysquare.politanrow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2160757304249077191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "politan-row-at-colony-square",
      "poi_latitude": "33.7871256",
      "poi_longitude": "-84.3821143",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-228-7941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9746-7471-b9aa-6ee0a915decf",
        "storage_key": "property/6767906449167742/01a03e5a-9746-7471-b9aa-6ee0a915decf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJizzK5GkF9YgRx82Y7VGN_B0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_858d69814c4a736486e682f4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Publix Super Market at The Plaza Midtown",
      "poi_type": "Shopping & Retail",
      "poi_address": "950 W Peachtree St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-da65-7619-8939-ce40f253b66c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-da65-7619-8939-ce40f253b66c",
        "storage_key": "property/6767906449167742/01a03e5b-da65-7619-8939-ce40f253b66c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1061&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=3963935707884851565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-the-plaza-midtown",
      "poi_latitude": "33.7804802",
      "poi_longitude": "-84.388809",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-253-3544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-97fa-73ca-9739-0077efbf1316.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-97fa-73ca-9739-0077efbf1316",
        "storage_key": "property/6767906449167742/01a03e5a-97fa-73ca-9739-0077efbf1316.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfTK9iWcE9YgRbZH2RIa6Ajc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_08184410d3616e11375295b6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "22 14th St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-db6d-743d-aedd-d24d802e022d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-db6d-743d-aedd-d24d802e022d",
        "storage_key": "property/6767906449167742/01a03e5b-db6d-743d-aedd-d24d802e022d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/midtownatlanta?utm_source=google&utm_medium=organic&utm_campaign=listings&ref_=US_TRF_ALL_UFG_WFM_FRSOC_1001220",
      "poi_directions_map_url": "https://maps.google.com/?cid=347012611710925997&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "33.7862472",
      "poi_longitude": "-84.38875569999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 470-552-4201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-97fa-73ca-9739-0077efbf1316.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-97fa-73ca-9739-0077efbf1316",
        "storage_key": "property/6767906449167742/01a03e5a-97fa-73ca-9739-0077efbf1316.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8xL51kwF9YgRrTycvSHW0AQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_72afa2ea44348d35bcb20a07",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "DGX",
      "poi_type": "Shopping & Retail",
      "poi_address": "881 Peachtree St NE Unit C, Atlanta, GA 30309, USA",
      "poi_short_description": "Convenience store supplying a selection of brand-name items at low prices, plus produce.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-e362-74fb-bc5c-70c07787b02b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-e362-74fb-bc5c-70c07787b02b",
        "storage_key": "property/6767906449167742/01a03e5b-e362-74fb-bc5c-70c07787b02b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/ga/atlanta/21822",
      "poi_directions_map_url": "https://maps.google.com/?cid=17706008653028195301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dgx",
      "poi_latitude": "33.7785867",
      "poi_longitude": "-84.3840154",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-954-3459",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-a7d0-7540-94b8-8de557114477.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a7d0-7540-94b8-8de557114477",
        "storage_key": "property/6767906449167742/01a03e5c-a7d0-7540-94b8-8de557114477.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJD3opWegF9YgR5fu8OQ9huPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_78511ae754df2ccfa2cfba9a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Savi Provisions - Midtown",
      "poi_type": "Shopping & Retail",
      "poi_address": "988 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Outpost of a local mini-chain for organic produce, wine, craft beer & gourmet meats & cheeses.",
      "poi_long_description": "Outpost of a local mini-chain for organic produce, wine, craft beer & gourmet meats & cheeses.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-e8c4-7570-aaa4-4e40dc040d9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-e8c4-7570-aaa4-4e40dc040d9f",
        "storage_key": "property/6767906449167742/01a03e5b-e8c4-7570-aaa4-4e40dc040d9f.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.saviprovisions.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9162878054315256210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savi-provisions---midtown",
      "poi_latitude": "33.7809654",
      "poi_longitude": "-84.384256",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 678-974-2120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-97fa-73ca-9739-0077efbf1316.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-97fa-73ca-9739-0077efbf1316",
        "storage_key": "property/6767906449167742/01a03e5a-97fa-73ca-9739-0077efbf1316.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXdIpn0IE9YgRkumuGwsVKX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_9e00859d5103901f4d80f275",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Walgreens Specialty Pharmacy at Piedmont Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "35 Collier Rd NW Ste 100, Atlanta, GA 30309, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-d733-74be-8e81-140a1bf297c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-d733-74be-8e81-140a1bf297c6",
        "storage_key": "property/6767906449167742/01a03e5b-d733-74be-8e81-140a1bf297c6.webp",
        "width": 750,
        "height": 421
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-35+collier+rd+nw-atlanta-ga-30309/id=13641",
      "poi_directions_map_url": "https://maps.google.com/?cid=2838279108254460789&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-specialty-pharmacy-at-piedmont-hospital",
      "poi_latitude": "33.8091725",
      "poi_longitude": "-84.3957444",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-350-9772",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-a7d5-714b-a5a6-dfd07c62007d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a7d5-714b-a5a6-dfd07c62007d",
        "storage_key": "property/6767906449167742/01a03e5c-a7d5-714b-a5a6-dfd07c62007d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtY7DB6oF9YgRdWvrpM-XYyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_de79083c4e3905c1cd24975c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "842 Peachtree St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-e9e2-7190-9bbd-f01b76da0ce0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-e9e2-7190-9bbd-f01b76da0ce0",
        "storage_key": "property/6767906449167742/01a03e5b-e9e2-7190-9bbd-f01b76da0ce0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/atlanta-ga-pharmacies/842-peachtree-street-ne-atlanta-ga-30308/storeid=2943?WT.mc_id=LS_GOOGLE_FS_2943",
      "poi_directions_map_url": "https://maps.google.com/?cid=15933037119015621559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "33.7774986",
      "poi_longitude": "-84.3845652",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-892-8468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9793-7161-80a4-9cb6066006d6",
        "storage_key": "property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiwRLxGIF9YgRtxMKyNeEHd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_7c1c641de1edd12e31792090",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Ponce City Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "675 Ponce De Leon Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Vibrant converted historic Sears building, now a market with a food hall, shops & living space.",
      "poi_long_description": "Vibrant converted historic Sears building, now a market with a food hall, shops & living space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e59-3f24-705b-81d4-da8685d12d82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-3f24-705b-81d4-da8685d12d82",
        "storage_key": "property/6767906449167742/01a03e59-3f24-705b-81d4-da8685d12d82.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://poncecitymarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14460613837555701121&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ponce-city-market",
      "poi_latitude": "33.7727683",
      "poi_longitude": "-84.3655967",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-900-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9801-725e-805f-35c5f5113205.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9801-725e-805f-35c5f5113205",
        "storage_key": "property/6767906449167742/01a03e5a-9801-725e-805f-35c5f5113205.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTTv9ohAE9YgRgRWbbatrrsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_7c5f66199c5279bf63cae1c5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Atlantic Station",
      "poi_type": "Shopping & Retail",
      "poi_address": "1380 Atlantic Dr NW, Atlanta, GA 30363, USA",
      "poi_short_description": "Upmarket retail complex with department & specialty stores, a multiplex & a range of dining options.",
      "poi_long_description": "Upmarket retail complex with department & specialty stores, a multiplex & a range of dining options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-fc59-7239-922e-5f0e58b4b167.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-fc59-7239-922e-5f0e58b4b167",
        "storage_key": "property/6767906449167742/01a03e5b-fc59-7239-922e-5f0e58b4b167.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://atlanticstation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16075264230802959861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlantic-station",
      "poi_latitude": "33.79249830000001",
      "poi_longitude": "-84.39651820000002",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-410-4010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9801-725e-805f-35c5f5113205.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9801-725e-805f-35c5f5113205",
        "storage_key": "property/6767906449167742/01a03e5a-9801-725e-805f-35c5f5113205.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJk8PKSvYE9YgR9a2Nw6XPFt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_5caafbf88d44bbfcf85e0842",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Midtown High School",
      "poi_type": "Education",
      "poi_address": "929 Charles Allen Dr NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-fd1c-760d-9362-5d3b87a139ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-fd1c-760d-9362-5d3b87a139ee",
        "storage_key": "property/6767906449167742/01a03e5b-fd1c-760d-9362-5d3b87a139ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantapublicschools.us/midtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=18124944716900365978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midtown-high-school",
      "poi_latitude": "33.7805714",
      "poi_longitude": "-84.3722454",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-802-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9797-741b-9826-f67bdb0bfd88",
        "storage_key": "property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcTOFGj4E9YgRmnZwoDC9iPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_a48bac734a4e7e30a38f63ef",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Virginia Highland Elementary School",
      "poi_type": "Education",
      "poi_address": "774 Virginia Ave NE, Atlanta, GA 30306, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://virginiahighland.atlantapublicschools.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5585150837372331685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-highland-elementary-school",
      "poi_latitude": "33.7818981",
      "poi_longitude": "-84.3621988",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-802-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9797-741b-9826-f67bdb0bfd88",
        "storage_key": "property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJTmyeiIF9YgRpaaNXhhxgk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_8553d86c6d5716e25ee16dc7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "David T. Howard Middle School",
      "poi_type": "Education",
      "poi_address": "551 John Wesley Dobbs Ave NE, Atlanta, GA 30312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-1342-71db-9f0d-230c6816b9df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-1342-71db-9f0d-230c6816b9df",
        "storage_key": "property/6767906449167742/01a03e5c-1342-71db-9f0d-230c6816b9df.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://howard.atlantapublicschools.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7462350126577969402&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "david-t-howard-middle-school",
      "poi_latitude": "33.7587659",
      "poi_longitude": "-84.3687987",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-802-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9797-741b-9826-f67bdb0bfd88",
        "storage_key": "property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJA4ihuAkE9YgR-mhFJOeXj2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_bdc2acc41334adcc8767b3c5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Primrose School of Midtown at Colony Square",
      "poi_type": "Education",
      "poi_address": "1197 Peachtree St NE Apt 554, Atlanta, GA 30361, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-f3c4-779a-8618-5501934ec0b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-f3c4-779a-8618-5501934ec0b6",
        "storage_key": "property/6767906449167742/01a03e5b-f3c4-779a-8618-5501934ec0b6.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.primroseschools.com/schools/midtown-colony-square/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=10215777039959737651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-midtown-at-colony-square",
      "poi_latitude": "33.7877156",
      "poi_longitude": "-84.3820715",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-745-9797",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9797-741b-9826-f67bdb0bfd88",
        "storage_key": "property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7aGRZEQE9YgRM0Vkoxe7xY0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_804e3a6ce9d454aedced41b9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "First Presbyterian Preschool",
      "poi_type": "Education",
      "poi_address": "1328 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-f65b-70ef-b5e6-ee4376067ab4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-f65b-70ef-b5e6-ee4376067ab4",
        "storage_key": "property/6767906449167742/01a03e5b-f65b-70ef-b5e6-ee4376067ab4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.firstprespreschoolatl.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11416351061185315093&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-presbyterian-preschool",
      "poi_latitude": "33.790715",
      "poi_longitude": "-84.3861151",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-228-7722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9797-741b-9826-f67bdb0bfd88",
        "storage_key": "property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy1WhTkUE9YgRFcEawc0Gb54",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_eec2e74bde3e1fcd7327e2b6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Bright Horizons at All Saints'",
      "poi_type": "Education",
      "poi_address": "644 W Peachtree St NW, Atlanta, GA 30308, USA",
      "poi_short_description": "Warm center with kind staff offering quality childcare, early preschool and pre-K instruction.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-f4d5-77ba-af91-03431ecf108e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-f4d5-77ba-af91-03431ecf108e",
        "storage_key": "property/6767906449167742/01a03e5b-f4d5-77ba-af91-03431ecf108e.webp",
        "width": 1152,
        "height": 768
      },
      "poi_business_url": "https://www.brighthorizons.com/daycare-centers/ga/atlanta/644-w-peachtree-st-nw-30308?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_term=weblink&utm_content=centerwebsite&IMS_SOURCE_SPECIFY=google%7Corganic%7Cgmb%7Cweblink%7Ccenterwebsite",
      "poi_directions_map_url": "https://maps.google.com/?cid=14837807289496452570&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bright-horizons-at-all-saints",
      "poi_latitude": "33.7720212",
      "poi_longitude": "-84.3879709",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 470-936-7618",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9797-741b-9826-f67bdb0bfd88",
        "storage_key": "property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU71kCWUE9YgR2j0joB176s0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_291cec4ae08e6e3621651027",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Georgia Institute of Technology-Dean's Office",
      "poi_type": "Education",
      "poi_address": "225 North Ave NW #202, Atlanta, GA 30332, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-fbef-778c-9c5e-3c0be3e5227f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-fbef-778c-9c5e-3c0be3e5227f",
        "storage_key": "property/6767906449167742/01a03e5b-fbef-778c-9c5e-3c0be3e5227f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gatech.edu/about/leadership",
      "poi_directions_map_url": "https://maps.google.com/?cid=2281686728971383656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-institute-of-technology-deans-office",
      "poi_latitude": "33.7724231",
      "poi_longitude": "-84.3947865",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-894-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9797-741b-9826-f67bdb0bfd88",
        "storage_key": "property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfwlvi2IE9YgRaPMPuf0tqh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "academic_department"
    },
    {
      "id": "ec_205688d9ce1c6d3c8e9ae3a7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Georgia State University",
      "poi_type": "Education",
      "poi_address": "Atlanta, GA 30302, USA",
      "poi_short_description": "Public research university located in the Downtown area & known for its sports & business programs.",
      "poi_long_description": "Public research university located in the Downtown area & known for its sports & business programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-77f8-758d-8be7-2576e4063acd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5a-77f8-758d-8be7-2576e4063acd",
        "storage_key": "property/6767906449167742/01a03e5a-77f8-758d-8be7-2576e4063acd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5386762121144725143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-state-university",
      "poi_latitude": "33.753068",
      "poi_longitude": "-84.38528190000001",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-413-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9797-741b-9826-f67bdb0bfd88",
        "storage_key": "property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJueHvE4YD9YgRl25c4JufwUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_f90230ace02c9350ccd9d2a5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Atlanta Speech School",
      "poi_type": "Education",
      "poi_address": "3160 Northside Pkwy NW, Atlanta, GA 30327, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5b-fde3-75bc-844d-d7276c2e464f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-fde3-75bc-844d-d7276c2e464f",
        "storage_key": "property/6767906449167742/01a03e5b-fde3-75bc-844d-d7276c2e464f.webp",
        "width": 640,
        "height": 427
      },
      "poi_business_url": "http://www.atlantaspeechschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2963595263744232869&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlanta-speech-school",
      "poi_latitude": "33.841681",
      "poi_longitude": "-84.4226733",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-233-5332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9797-741b-9826-f67bdb0bfd88",
        "storage_key": "property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi6wxLFoF9YgRpU2ByTDOICk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_ba1466986d9dd22b39eb2cb4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Atlanta International School",
      "poi_type": "Education",
      "poi_address": "2890 N Fulton Dr NE, Atlanta, GA 30305, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-25bb-74ba-bafe-709943fbef7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-25bb-74ba-bafe-709943fbef7e",
        "storage_key": "property/6767906449167742/01a03e5c-25bb-74ba-bafe-709943fbef7e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.aischool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8116433891789394436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlanta-international-school",
      "poi_latitude": "33.8328593",
      "poi_longitude": "-84.37793640000001",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-841-3840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9797-741b-9826-f67bdb0bfd88",
        "storage_key": "property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFWyrU5IF9YgRBFIMM59do3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_1bc129209b5d8b6619de3daf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Center Stage Theater",
      "poi_type": "Entertainment",
      "poi_address": "1374 W Peachtree St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Intimate performing arts venue seats 1,050 with premier lighting & sound & separate lounge space.",
      "poi_long_description": "Intimate performing arts venue seats 1,050 with premier lighting & sound & separate lounge space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-0320-7555-872c-03010cd253d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-0320-7555-872c-03010cd253d6",
        "storage_key": "property/6767906449167742/01a03e5c-0320-7555-872c-03010cd253d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.centerstage-atlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16982912977202433654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "center-stage-theater",
      "poi_latitude": "33.7922155",
      "poi_longitude": "-84.3879559",
      "poi_miles_from_property": "213 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-885-1365",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9793-7161-80a4-9cb6066006d6",
        "storage_key": "property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyXLceFAE9YgRds6FmV9tr-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_5a9da959fda4791af7ebff38",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Center For Puppetry Arts",
      "poi_type": "Entertainment",
      "poi_address": "1404 Spring St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Long-standing puppetry museum with a variety of exhibits, performances, workshops & classes.",
      "poi_long_description": "Long-standing puppetry museum with a variety of exhibits, performances, workshops & classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-08b9-71cf-adfb-2a158ab28aee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-08b9-71cf-adfb-2a158ab28aee",
        "storage_key": "property/6767906449167742/01a03e5c-08b9-71cf-adfb-2a158ab28aee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.puppet.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8253606720874116330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "center-for-puppetry-arts",
      "poi_latitude": "33.792875",
      "poi_longitude": "-84.38985989999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-873-3391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-979c-704b-acfe-dd528bf5d8b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-979c-704b-acfe-dd528bf5d8b8",
        "storage_key": "property/6767906449167742/01a03e5a-979c-704b-acfe-dd528bf5d8b8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4fRXllAE9YgR6nR6SZWzinI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_5e359726dbf892ebe113370b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "High Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "1280 Peachtree Rd NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Museum known for its diverse art collection & modern architecture by Richard Meier & Renzo Piano.",
      "poi_long_description": "Museum known for its diverse art collection & modern architecture by Richard Meier & Renzo Piano.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-193b-7351-a902-cb6491a5337a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-193b-7351-a902-cb6491a5337a",
        "storage_key": "property/6767906449167742/01a03e5c-193b-7351-a902-cb6491a5337a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.high.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17827694190187609074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "high-museum-of-art",
      "poi_latitude": "33.7900632",
      "poi_longitude": "-84.38555199999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-733-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-979c-704b-acfe-dd528bf5d8b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-979c-704b-acfe-dd528bf5d8b8",
        "storage_key": "property/6767906449167742/01a03e5a-979c-704b-acfe-dd528bf5d8b8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8bUMEUE9YgR8nttKmmxaPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_7f5da1cf914aa23005cf3412",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Alliance Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1280 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Acclaimed theater company featuring house productions of major plays & acting workshops.",
      "poi_long_description": "Acclaimed theater company featuring house productions of major plays & acting workshops.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-2c09-75ac-86c3-dce60af00d8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-2c09-75ac-86c3-dce60af00d8f",
        "storage_key": "property/6767906449167742/01a03e5c-2c09-75ac-86c3-dce60af00d8f.webp",
        "width": 1280,
        "height": 1040
      },
      "poi_business_url": "http://alliancetheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15996732928718111168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alliance-theatre",
      "poi_latitude": "33.7892466",
      "poi_longitude": "-84.38540859999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-733-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9793-7161-80a4-9cb6066006d6",
        "storage_key": "property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8bUMEUE9YgRwIEJJ9jP_90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_624348a8718b85fd97cf962d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Fox Theatre",
      "poi_type": "Entertainment",
      "poi_address": "660 Peachtree St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Restored opulent theater built in 1920s with 3,600-pipe organ hosts ballet, movies & other events.",
      "poi_long_description": "Restored opulent theater built in 1920s with 3,600-pipe organ hosts ballet, movies & other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-1c44-74ca-8b4c-6a33639232c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-1c44-74ca-8b4c-6a33639232c5",
        "storage_key": "property/6767906449167742/01a03e5c-1c44-74ca-8b4c-6a33639232c5.webp",
        "width": 1280,
        "height": 949
      },
      "poi_business_url": "https://www.foxtheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1917821642260137630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fox-theatre",
      "poi_latitude": "33.7726136",
      "poi_longitude": "-84.3853395",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 855-285-8499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9793-7161-80a4-9cb6066006d6",
        "storage_key": "property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ28DQdm8E9YgRnsZ4YZ94nRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_ac940084fbc6c232300bf14d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Landmark's Midtown Art Cinema",
      "poi_type": "Entertainment",
      "poi_address": "931 Monroe Dr NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Movie theater screening new releases as well as independent, foreign & avant-garde flicks.",
      "poi_long_description": "Movie theater screening new releases as well as independent, foreign & avant-garde flicks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-1358-71db-b4f7-51e5a7caf65b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-1358-71db-b4f7-51e5a7caf65b",
        "storage_key": "property/6767906449167742/01a03e5c-1358-71db-b4f7-51e5a7caf65b.webp",
        "width": 850,
        "height": 315
      },
      "poi_business_url": "https://www.landmarktheatres.com/atlanta/midtown-art-cinema",
      "poi_directions_map_url": "https://maps.google.com/?cid=7135845890094996050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "landmarks-midtown-art-cinema",
      "poi_latitude": "33.779128",
      "poi_longitude": "-84.36725009999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-879-0160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-a7df-77ca-a2ed-19c499924633.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a7df-77ca-a2ed-19c499924633",
        "storage_key": "property/6767906449167742/01a03e5c-a7df-77ca-a2ed-19c499924633.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYwbERYE9YgRUhoLmweeB2M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_0b73820f0203fb58e0c1e190",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Plaza Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1049 Ponce De Leon Ave NE, Atlanta, GA 30306, USA",
      "poi_short_description": "Independent movie theater showcases cult classics & midnight movies on Friday on the silver screen.",
      "poi_long_description": "Independent movie theater showcases cult classics & midnight movies on Friday on the silver screen.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-1f10-711b-b8e8-824b01fde5ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-1f10-711b-b8e8-824b01fde5ab",
        "storage_key": "property/6767906449167742/01a03e5c-1f10-711b-b8e8-824b01fde5ab.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.plazaatlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5819026170921268730&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plaza-theatre",
      "poi_latitude": "33.7734567",
      "poi_longitude": "-84.3530406",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 470-410-1939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-a7df-77ca-a2ed-19c499924633.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a7df-77ca-a2ed-19c499924633",
        "storage_key": "property/6767906449167742/01a03e5c-a7df-77ca-a2ed-19c499924633.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJP47X-6MG9YgR-rV20HhVwVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_6d022679ba0a51cfe66d5724",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Skyline Park",
      "poi_type": "Entertainment",
      "poi_address": "Ponce City Market, 675 Ponce De Leon Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Cheery place for games, rides & mini golf, plus beer & snacks, on the Ponce City Market roof.",
      "poi_long_description": "Cheery place for games, rides & mini golf, plus beer & snacks, on the Ponce City Market roof.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-16c4-768b-bc00-e2b780462638.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-16c4-768b-bc00-e2b780462638",
        "storage_key": "property/6767906449167742/01a03e5c-16c4-768b-bc00-e2b780462638.webp",
        "width": 1080,
        "height": 811
      },
      "poi_business_url": "https://poncecityroof.com/skyline-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10941119418121271072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skyline-park",
      "poi_latitude": "33.77282710000001",
      "poi_longitude": "-84.3655928",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-999-1530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9793-7161-80a4-9cb6066006d6",
        "storage_key": "property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp-YA7RAE9YgRIDc_aiSq1pc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_136464cd7c8af3c884d9b882",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Piedmont Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Atlanta, GA 30309, USA",
      "poi_short_description": "Sprawling park featuring jogging paths, basketball courts, dog parks, a farmers' market & more.",
      "poi_long_description": "Sprawling park featuring jogging paths, basketball courts, dog parks, a farmers' market & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-1088-766e-a924-1ce513085de6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5a-1088-766e-a924-1ce513085de6",
        "storage_key": "property/6767906449167742/01a03e5a-1088-766e-a924-1ce513085de6.webp",
        "width": 736,
        "height": 485
      },
      "poi_business_url": "https://piedmontpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17559229622006002958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-park",
      "poi_latitude": "33.7879265",
      "poi_longitude": "-84.37216819999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-875-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9808-7709-9c39-bd6923972362.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9808-7709-9c39-bd6923972362",
        "storage_key": "property/6767906449167742/01a03e5a-9808-7709-9c39-bd6923972362.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGaxkUDkE9YgRDjUv9U7qrvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c0843a8dfb8ed3d370eedd9e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "MODA (Museum of Design Atlanta)",
      "poi_type": "Entertainment",
      "poi_address": "1315 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Small gallery space featuring rotating exhibitions that explore the impact of design on art & life.",
      "poi_long_description": "Small gallery space featuring rotating exhibitions that explore the impact of design on art & life.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-2484-71f8-b172-c2691e5027c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-2484-71f8-b172-c2691e5027c1",
        "storage_key": "property/6767906449167742/01a03e5c-2484-71f8-b172-c2691e5027c1.webp",
        "width": 746,
        "height": 472
      },
      "poi_business_url": "http://www.museumofdesign.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=746627984300481121&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moda-museum-of-design-atlanta",
      "poi_latitude": "33.790648",
      "poi_longitude": "-84.384635",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-979-6455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-979c-704b-acfe-dd528bf5d8b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-979c-704b-acfe-dd528bf5d8b8",
        "storage_key": "property/6767906449167742/01a03e5a-979c-704b-acfe-dd528bf5d8b8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJzal6QUUE9YgRYZqYJzKOXAo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_340efd5c536052f4bb885dc7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Piedmont Atlanta",
      "poi_type": "Health and Wellness",
      "poi_address": "1968 Peachtree Rd NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-2418-7202-84da-d9214b609c06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-2418-7202-84da-d9214b609c06",
        "storage_key": "property/6767906449167742/01a03e5c-2418-7202-84da-d9214b609c06.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-atlanta?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MTI5OTY4MzYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10361705813315035831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-atlanta",
      "poi_latitude": "33.8088868",
      "poi_longitude": "-84.394939",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-605-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-97f8-77ea-b709-e54ca5ba2c96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-97f8-77ea-b709-e54ca5ba2c96",
        "storage_key": "property/6767906449167742/01a03e5a-97f8-77ea-b709-e54ca5ba2c96.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ2L4-KkF9YgRtyK-3YkszI8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_18e5edfb98f850b96a20d883",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Emory University Hospital Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "550 Peachtree St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-20e2-73db-bd22-995116399a81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5a-20e2-73db-bd22-995116399a81",
        "storage_key": "property/6767906449167742/01a03e5a-20e2-73db-bd22-995116399a81.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.emoryhealthcare.org/locations/hospitals/emory-university-hospital-midtown?&utm_campaign=brand_euh_ra_gmb-locations&utm_source=google&utm_medium=gmb&utm_content=gmb_locations?&utm_campaign=brand_all_non&utm_source=google&utm_medium=gmb&utm_content=gmb-locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=15043808532116501154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emory-university-hospital-midtown",
      "poi_latitude": "33.7686442",
      "poi_longitude": "-84.38619290000001",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-686-4411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-97f8-77ea-b709-e54ca5ba2c96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-97f8-77ea-b709-e54ca5ba2c96",
        "storage_key": "property/6767906449167742/01a03e5a-97f8-77ea-b709-e54ca5ba2c96.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ42AWonoE9YgRonLLiSdYxtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_e32ae13c05d2518d25c86b21",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Atlanta Urgent Care at Peachtree",
      "poi_type": "Health and Wellness",
      "poi_address": "2140 Peachtree Rd Ste 360, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-316d-756c-b0b8-9ca891dccb83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-316d-756c-b0b8-9ca891dccb83",
        "storage_key": "property/6767906449167742/01a03e5c-316d-756c-b0b8-9ca891dccb83.webp",
        "width": 889,
        "height": 500
      },
      "poi_business_url": "https://www.atlantaurgentcare.com/atlanta-urgent-care-at-peachtree",
      "poi_directions_map_url": "https://maps.google.com/?cid=4945566955331047432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlanta-urgent-care-at-peachtree",
      "poi_latitude": "33.8125815",
      "poi_longitude": "-84.3931539",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-805-7425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9793-7161-80a4-9cb6066006d6",
        "storage_key": "property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz0WJYqgF9YgRCNBqcfEuokQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_90a0a529ac6de69cb52ce3da",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "AllCare Primary & Immediate Care: Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "805 Peachtree St NE Unit A, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-3b1e-732d-a191-8112a1888fa3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-3b1e-732d-a191-8112a1888fa3",
        "storage_key": "property/6767906449167742/01a03e5c-3b1e-732d-a191-8112a1888fa3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.allcare-ga.com/location/midtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=12535664565043690199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allcare-primary--immediate-care-midtown",
      "poi_latitude": "33.7764832",
      "poi_longitude": "-84.38401979999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 844-779-7026",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9793-7161-80a4-9cb6066006d6",
        "storage_key": "property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDQ5PE6oF9YgR13rhToGg960",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_340575693d9c670a2dc27507",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "AHF Pharmacy - Peachtree",
      "poi_type": "Health and Wellness",
      "poi_address": "1438 W Peachtree St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-316c-76cc-9bd1-98b31767b16b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-316c-76cc-9bd1-98b31767b16b",
        "storage_key": "property/6767906449167742/01a03e5c-316c-76cc-9bd1-98b31767b16b.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://ahfpharmacy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17038347053401178898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ahf-pharmacy---peachtree",
      "poi_latitude": "33.793951",
      "poi_longitude": "-84.3884128",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 404-879-3990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-a7d5-714b-a5a6-dfd07c62007d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a7d5-714b-a5a6-dfd07c62007d",
        "storage_key": "property/6767906449167742/01a03e5c-a7d5-714b-a5a6-dfd07c62007d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrWR851ME9YgREgPNPV9edOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_d7941aa36fc70f335da039c5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Northside Medical Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "1110 W Peachtree St NW, Atlanta, GA 30342, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-4247-7089-94fa-9fb59dd535e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-4247-7089-94fa-9fb59dd535e7",
        "storage_key": "property/6767906449167742/01a03e5c-4247-7089-94fa-9fb59dd535e7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.northside.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13207439122071304450&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northside-medical-midtown",
      "poi_latitude": "33.7853927",
      "poi_longitude": "-84.38816829999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-875-2640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9793-7161-80a4-9cb6066006d6",
        "storage_key": "property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmePxIAcF9YgRAjmoz-c_Src",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_348b76a2a1606dd4e4ca0624",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Barry's Midtown Atlanta",
      "poi_type": "Health and Wellness",
      "poi_address": "1105 W Peachtree St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-42fc-72b6-b990-5af7bfce386c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-42fc-72b6-b990-5af7bfce386c",
        "storage_key": "property/6767906449167742/01a03e5c-42fc-72b6-b990-5af7bfce386c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://barrys.com/studio/midtown-atlanta",
      "poi_directions_map_url": "https://maps.google.com/?cid=13504651076706225155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barrys-midtown-atlanta",
      "poi_latitude": "33.78471",
      "poi_longitude": "-84.386498",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 470-762-9450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9793-7161-80a4-9cb6066006d6",
        "storage_key": "property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9bOLcS0F9YgRA8yrgpooars",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_e5623a44011f59a0084ae616",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "933 Peachtree St NE #939A, Atlanta, GA 30309, USA",
      "poi_short_description": "Group, treadmill-based workout studio, featuring certified instructors and fitness training in an energetic environment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-4a7f-7309-a639-2134396348fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-4a7f-7309-a639-2134396348fe",
        "storage_key": "property/6767906449167742/01a03e5c-4a7f-7309-a639-2134396348fe.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/atlanta-georgia-0137?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=621678546688391647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "33.780276",
      "poi_longitude": "-84.3839747",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-747-7107",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9793-7161-80a4-9cb6066006d6",
        "storage_key": "property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCWpDnUIE9YgR37nXK1iloAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_eac46673ebb73a581ccebed0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Body Alive Midtown Atlanta",
      "poi_type": "Health and Wellness",
      "poi_address": "3 10th St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-448d-7469-be7a-4a3fd69a3f7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-448d-7469-be7a-4a3fd69a3f7c",
        "storage_key": "property/6767906449167742/01a03e5c-448d-7469-be7a-4a3fd69a3f7c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bodyalivefitness.com/location/body-alive-midtown-atlanta/?utm_source=GoogleBusinessProfile&utm_medium=Website&utm_campaign=MapLabs",
      "poi_directions_map_url": "https://maps.google.com/?cid=7314774484176795890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "body-alive-midtown-atlanta",
      "poi_latitude": "33.781675",
      "poi_longitude": "-84.3885335",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-855-1261",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9797-741b-9826-f67bdb0bfd88",
        "storage_key": "property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8TW8q38F9YgR8vhyVaNMg2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_4ec008faa253b34b97d84abf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Atlanta Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1345 Piedmont Ave NE, Atlanta, GA 30309, USA",
      "poi_short_description": "30-acre garden with a conservatory & fountains playing host to concerts, cocktail parties & more.",
      "poi_long_description": "30-acre garden with a conservatory & fountains playing host to concerts, cocktail parties & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-2649-74c9-ad6a-fe18da5f6163.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5a-2649-74c9-ad6a-fe18da5f6163",
        "storage_key": "property/6767906449167742/01a03e5a-2649-74c9-ad6a-fe18da5f6163.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantabg.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11595354526965683893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlanta-botanical-garden",
      "poi_latitude": "33.7899568",
      "poi_longitude": "-84.37259879999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-876-5859",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9793-7161-80a4-9cb6066006d6",
        "storage_key": "property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RXVJTgE9YgRtdaB6IH56qA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_efe18de10c69f3b76d69cc43",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Piedmont Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Park Dr NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Fenced off-leash dog park on 3 acres, with small- & large-breed areas, shade, water & benches.",
      "poi_long_description": "Fenced off-leash dog park on 3 acres, with small- & large-breed areas, shade, water & benches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-4491-74eb-8136-208863e3457b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-4491-74eb-8136-208863e3457b",
        "storage_key": "property/6767906449167742/01a03e5c-4491-74eb-8136-208863e3457b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.piedmontpark.org/things-to-do/dog-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16865513577315875636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-dog-park",
      "poi_latitude": "33.7879898",
      "poi_longitude": "-84.37115949999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-875-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9808-7709-9c39-bd6923972362.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9808-7709-9c39-bd6923972362",
        "storage_key": "property/6767906449167742/01a03e5a-9808-7709-9c39-bd6923972362.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-bEWbTkE9YgRNLtwwj1XDuo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_8ab5b9738f2f45558095567e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Pershing Point Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1720 Peachtree St NE Unit 333, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-4d1e-74c7-bc34-0a2c9c1ff29d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-4d1e-74c7-bc34-0a2c9c1ff29d",
        "storage_key": "property/6767906449167742/01a03e5c-4d1e-74c7-bc34-0a2c9c1ff29d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.atlantaga.gov/government/departments/department-parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=15821385347496745285&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pershing-point-park",
      "poi_latitude": "33.7939667",
      "poi_longitude": "-84.387545",
      "poi_miles_from_property": "427 ft",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9808-7709-9c39-bd6923972362.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9808-7709-9c39-bd6923972362",
        "storage_key": "property/6767906449167742/01a03e5a-9808-7709-9c39-bd6923972362.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh5m9BFAE9YgRRRkd9CXakNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_173ef93c8d5ccbf40fb15328",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Colony Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "1197 Peachtree St NE, Atlanta, GA 30361, USA",
      "poi_short_description": "Mixed-use complex featuring professional offices, shops, services, restaurants & frequent events.",
      "poi_long_description": "Mixed-use complex featuring professional offices, shops, services, restaurants & frequent events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-5545-701e-8b9d-c4a1156f5370.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-5545-701e-8b9d-c4a1156f5370",
        "storage_key": "property/6767906449167742/01a03e5c-5545-701e-8b9d-c4a1156f5370.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://colonysquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2240213496914822969&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colony-square",
      "poi_latitude": "33.7873463",
      "poi_longitude": "-84.38246629999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-965-9091",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9801-725e-805f-35c5f5113205.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9801-725e-805f-35c5f5113205",
        "storage_key": "property/6767906449167742/01a03e5a-9801-725e-805f-35c5f5113205.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgbZHQ0QE9YgROcekaE7WFh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_2b6c18471730cd48c53c34f7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Renaissance Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "501-515 Piedmont Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Large green space featuring a clean fenced-in area for dogs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-7562-77fa-9f36-3f75d2a746fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-7562-77fa-9f36-3f75d2a746fc",
        "storage_key": "property/6767906449167742/01a03e5c-7562-77fa-9f36-3f75d2a746fc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8440767784127143056&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "renaissance-park",
      "poi_latitude": "33.7680916",
      "poi_longitude": "-84.3806293",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9808-7709-9c39-bd6923972362.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9808-7709-9c39-bd6923972362",
        "storage_key": "property/6767906449167742/01a03e5a-9808-7709-9c39-bd6923972362.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZSTwnEE9YgRkJx1HJShI3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_92453769bdc54689d9d76cb2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Hardy Ivy Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 W Peachtree St NW, Atlanta, GA 30303, USA",
      "poi_short_description": "Small square with a monument for the first European settler in what is now Atlanta.",
      "poi_long_description": "Small square with a monument for the first European settler in what is now Atlanta.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-5a5c-7467-a7c5-3dd2f93ed822.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-5a5c-7467-a7c5-3dd2f93ed822",
        "storage_key": "property/6767906449167742/01a03e5c-5a5c-7467-a7c5-3dd2f93ed822.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantadowntown.com/go/hardy-ivy-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16928630230156272432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hardy-ivy-park",
      "poi_latitude": "33.7632905",
      "poi_longitude": "-84.3874092",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9808-7709-9c39-bd6923972362.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9808-7709-9c39-bd6923972362",
        "storage_key": "property/6767906449167742/01a03e5a-9808-7709-9c39-bd6923972362.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh_yak3kE9YgRMGNnqoCT7uo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_14fec79bab0ad6178b7e5c0a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Folk Art Park",
      "poi_type": "Entertainment",
      "poi_address": "Courtland St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Park showcasing murals and other artwork, spread out over several blocks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-62bf-721c-baab-6f719cb0ed79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-62bf-721c-baab-6f719cb0ed79",
        "storage_key": "property/6767906449167742/01a03e5c-62bf-721c-baab-6f719cb0ed79.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6401780090008581908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "folk-art-park",
      "poi_latitude": "33.764049",
      "poi_longitude": "-84.38403459999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9793-7161-80a4-9cb6066006d6",
        "storage_key": "property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN9qByXAE9YgRFDch4xKx11g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "ec_3539dc89e3db94d72e628b36",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Historic Fourth Ward Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "680 Dallas St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "A 17-acre park with a splash fountain, skate park & amphitheater, adjacent to the Atlanta Beltline.",
      "poi_long_description": "A 17-acre park with a splash fountain, skate park & amphitheater, adjacent to the Atlanta Beltline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-5441-7609-9769-fdf43989aec6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-5441-7609-9769-fdf43989aec6",
        "storage_key": "property/6767906449167742/01a03e5c-5441-7609-9769-fdf43989aec6.webp",
        "width": 1280,
        "height": 667
      },
      "poi_business_url": "http://www.h4wpc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1819443021458306877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "historic-fourth-ward-park",
      "poi_latitude": "33.7694043",
      "poi_longitude": "-84.3647968",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-546-6813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9808-7709-9c39-bd6923972362.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9808-7709-9c39-bd6923972362",
        "storage_key": "property/6767906449167742/01a03e5a-9808-7709-9c39-bd6923972362.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZSnz-A8E9YgRPfcVx8n1Pxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_36e606b3925241d780c24911",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Woodruff Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "91 Peachtree St, Atlanta, GA 30303, USA",
      "poi_short_description": "City park with 2 fountains, playgrounds, sculptures, chess court & pavilion, plus events.",
      "poi_long_description": "City park with 2 fountains, playgrounds, sculptures, chess court & pavilion, plus events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-636e-7263-b842-40bb53a51326.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-636e-7263-b842-40bb53a51326",
        "storage_key": "property/6767906449167742/01a03e5c-636e-7263-b842-40bb53a51326.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantaga.gov/government/departments/department-parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=10797897627385162082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodruff-park",
      "poi_latitude": "33.755217",
      "poi_longitude": "-84.388628",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 404-546-6744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9808-7709-9c39-bd6923972362.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9808-7709-9c39-bd6923972362",
        "storage_key": "property/6767906449167742/01a03e5a-9808-7709-9c39-bd6923972362.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXwkh_4YD9YgRYmlTsa7W2ZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_570d68a18946a7826fce38de",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Arts Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-520e-720c-8d96-8de234e7e45b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5a-520e-720c-8d96-8de234e7e45b",
        "storage_key": "property/6767906449167742/01a03e5a-520e-720c-8d96-8de234e7e45b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.itsmarta.com/Arts-Center.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6693853067366476356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arts-center",
      "poi_latitude": "33.78918",
      "poi_longitude": "-84.38727999999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9c71-7287-a2ca-98f33b1ab677.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9c71-7287-a2ca-98f33b1ab677",
        "storage_key": "property/6767906449167742/01a03e5a-9c71-7287-a2ca-98f33b1ab677.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6XSS4FoE9YgRRKoJM-ZX5Vw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_d11e5238c0ecedc955f90c69",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Midtown",
      "poi_type": "Transportation & Transit",
      "poi_address": "Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-7cc1-711d-90cc-b7dc86d6068a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5a-7cc1-711d-90cc-b7dc86d6068a",
        "storage_key": "property/6767906449167742/01a03e5a-7cc1-711d-90cc-b7dc86d6068a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/Midtown.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3874113686536918320&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midtown",
      "poi_latitude": "33.78107",
      "poi_longitude": "-84.38632",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9c71-7287-a2ca-98f33b1ab677.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9c71-7287-a2ca-98f33b1ab677",
        "storage_key": "property/6767906449167742/01a03e5a-9c71-7287-a2ca-98f33b1ab677.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJdym9WF0E9YgRMBWDOd-dwzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_b427212c0c7403037947a5ab",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "North Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "713 W Peachtree St NW, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-56c4-762b-84e0-b55947ea32d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5a-56c4-762b-84e0-b55947ea32d8",
        "storage_key": "property/6767906449167742/01a03e5a-56c4-762b-84e0-b55947ea32d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/North-Ave.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6649073214810790357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-ave",
      "poi_latitude": "33.77179",
      "poi_longitude": "-84.38709",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9c71-7287-a2ca-98f33b1ab677.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9c71-7287-a2ca-98f33b1ab677",
        "storage_key": "property/6767906449167742/01a03e5a-9c71-7287-a2ca-98f33b1ab677.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJu65s0W4E9YgR1ZlcTtxARlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_dc38e3ebbee7c4f5d4dc769b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Civic Center Marta Station (Northbound)",
      "poi_type": "Transportation & Transit",
      "poi_address": "435 W Peachtree St NW, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-6a7a-75e8-b24b-e5a83e68686b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-6a7a-75e8-b24b-e5a83e68686b",
        "storage_key": "property/6767906449167742/01a03e5c-6a7a-75e8-b24b-e5a83e68686b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://cobbcounty.org/index.php?option=com_content&view=category&layout=blog&id=426&Itemid=2071",
      "poi_directions_map_url": "https://maps.google.com/?cid=14796171962493795015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "civic-center-marta-station-northbound",
      "poi_latitude": "33.7667382",
      "poi_longitude": "-84.38737359999999",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9c71-7287-a2ca-98f33b1ab677.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9c71-7287-a2ca-98f33b1ab677",
        "storage_key": "property/6767906449167742/01a03e5a-9c71-7287-a2ca-98f33b1ab677.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9cNVQ3oE9YgRx3oJpAGQVs0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_9a391c114ce4f6394d7d71ef",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Amtrak",
      "poi_type": "Transportation & Transit",
      "poi_address": "1688 Peachtree Rd NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-6ff1-7788-af00-4950dd251630.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-6ff1-7788-af00-4950dd251630",
        "storage_key": "property/6767906449167742/01a03e5c-6ff1-7788-af00-4950dd251630.webp",
        "width": 679,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/stations/atl",
      "poi_directions_map_url": "https://maps.google.com/?cid=11594273034950126537&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amtrak",
      "poi_latitude": "33.7993975",
      "poi_longitude": "-84.3926057",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 866-332-0334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9793-7161-80a4-9cb6066006d6",
        "storage_key": "property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa4Hqac4F9YgRyasXbeUh56A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_d30766a92058c156cdc578d0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "MAA Piedmont Park",
      "poi_type": "Transportation & Transit",
      "poi_address": "250 10th St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-8125-7518-9837-16d9b0b4e8bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-8125-7518-9837-16d9b0b4e8bd",
        "storage_key": "property/6767906449167742/01a03e5c-8125-7518-9837-16d9b0b4e8bd.webp",
        "width": 1280,
        "height": 796
      },
      "poi_business_url": "https://www.maac.com/georgia/atlanta/maa-piedmont-park/?utm_medium=local%20listing&utm_source=google&utm_campaign=gmb&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=5198719732498280806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maa-piedmont-park",
      "poi_latitude": "33.7820047",
      "poi_longitude": "-84.37885639999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-905-1686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9793-7161-80a4-9cb6066006d6",
        "storage_key": "property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf-aCvkEE9YgRZrFffg2QJUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "real_estate_agency"
    },
    {
      "id": "ec_8d38e6482ac08802cacdba52",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "The Atlanta Beltline Eastside Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Atlanta Beltline Eastside Trl, Atlanta, GA 30312, USA",
      "poi_short_description": "Multiuse trail for walking, biking or jogging through the city past restaurants.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-75c3-72b1-9696-73475683001b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-75c3-72b1-9696-73475683001b",
        "storage_key": "property/6767906449167742/01a03e5c-75c3-72b1-9696-73475683001b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://beltline.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7911417990981684592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-atlanta-beltline-eastside-trail",
      "poi_latitude": "33.7819037",
      "poi_longitude": "-84.36849160000001",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-546-0311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9808-7709-9c39-bd6923972362.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9808-7709-9c39-bd6923972362",
        "storage_key": "property/6767906449167742/01a03e5a-9808-7709-9c39-bd6923972362.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJS7N6gJcF9YgRcA0ZDr8Ay20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_bd128578795ef19c1506de63",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Hartsfield-Jackson Atlanta International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6000 N Terminal Pkwy Ste 4000, Atlanta, GA 30320, USA",
      "poi_short_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_long_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-7ab5-77f1-8b7c-bcbe94b1cc2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-7ab5-77f1-8b7c-bcbe94b1cc2e",
        "storage_key": "property/6767906449167742/01a03e5c-7ab5-77f1-8b7c-bcbe94b1cc2e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690397784234438728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hartsfield-jackson-atlanta-international-airport",
      "poi_latitude": "33.6324187",
      "poi_longitude": "-84.4333116",
      "poi_miles_from_property": "14.5 mi",
      "poi_walking_minutes": "5 hours 26 mins",
      "poi_biking_minutes": "1 hour 47 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 800-897-1910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-a7ef-718c-b5fb-733cca3b5273.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a7ef-718c-b5fb-733cca3b5273",
        "storage_key": "property/6767906449167742/01a03e5c-a7ef-718c-b5fb-733cca3b5273.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVkD4S_99IgRSLCSGO-jF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_4cc1690da66f3793629d4c20",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Equifax",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1550 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-a0c1-7144-9720-054980ab1253.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a0c1-7144-9720-054980ab1253",
        "storage_key": "property/6767906449167742/01a03e5c-a0c1-7144-9720-054980ab1253.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.equifax.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11966891513933177530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "equifax",
      "poi_latitude": "33.7965403",
      "poi_longitude": "-84.3885395",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 888-202-4025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9793-7161-80a4-9cb6066006d6",
        "storage_key": "property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGTMTg1EE9YgRuqKfuW3wEqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_4385ece1cc42075509b1144b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Invesco Atlanta",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1331 Spring St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-8635-711d-9c04-95142237ba8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-8635-711d-9c04-95142237ba8d",
        "storage_key": "property/6767906449167742/01a03e5c-8635-711d-9c04-95142237ba8d.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.invesco.com/us/en/country-splash.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=1046754433332020491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "invesco-atlanta",
      "poi_latitude": "33.79134760000001",
      "poi_longitude": "-84.3889903",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 800-241-5477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9793-7161-80a4-9cb6066006d6",
        "storage_key": "property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa1cLJ6sF9YgRCwXSdZzRhg4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "ec_0fc2aa5bb4853154a22d2e05",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "NCR Voyix - Global Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "864 Spring St NW, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-8a00-75eb-b9a0-062aa22e98e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-8a00-75eb-b9a0-062aa22e98e5",
        "storage_key": "property/6767906449167742/01a03e5c-8a00-75eb-b9a0-062aa22e98e5.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.ncrvoyix.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6849285215794267972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ncr-voyix---global-headquarters",
      "poi_latitude": "33.7792377",
      "poi_longitude": "-84.38902759999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 800-225-5627",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9793-7161-80a4-9cb6066006d6",
        "storage_key": "property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIxrEKCSj9YgRRIfAXJ2MDV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_037689087dec5aa230f23d8e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "One Coca-Cola Plaza",
      "poi_type": "Major Employers & Offices",
      "poi_address": "528 Luckie St NW, Atlanta, GA 30313, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-71ce-71be-982e-7a153eeb4f60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5a-71ce-71be-982e-7a153eeb4f60",
        "storage_key": "property/6767906449167742/01a03e5a-71ce-71be-982e-7a153eeb4f60.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.coca-colacompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12947067275745438064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "one-coca-cola-plaza",
      "poi_latitude": "33.7711478",
      "poi_longitude": "-84.397268",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-676-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9793-7161-80a4-9cb6066006d6",
        "storage_key": "property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv5ISQokD9YgRcCnkPRc5rbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_d3ad0a6bef549c0daaab6a8a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Turner Entertainment Networks",
      "poi_type": "Major Employers & Offices",
      "poi_address": "The Mansion, 1050 Techwood Dr NW, Atlanta, GA 30318, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-90c2-778e-943a-db48977c7d03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-90c2-778e-943a-db48977c7d03",
        "storage_key": "property/6767906449167742/01a03e5c-90c2-778e-943a-db48977c7d03.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9452901516173101675&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "turner-entertainment-networks",
      "poi_latitude": "33.7829713",
      "poi_longitude": "-84.3929721",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-827-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9793-7161-80a4-9cb6066006d6",
        "storage_key": "property/6767906449167742/01a03e5a-9793-7161-80a4-9cb6066006d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYXIdVF4E9YgRa8o_aNhzL4M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_dca597ed68db98031392fb9d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Emory University",
      "poi_type": "Education",
      "poi_address": "201 Dowman Dr, Atlanta, GA 30322, USA",
      "poi_short_description": "Research-geared private school founded in 1836 & renowned for its healthcare program.",
      "poi_long_description": "Research-geared private school founded in 1836 & renowned for its healthcare program.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e59-49a2-76df-981e-b30c0129bf83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-49a2-76df-981e-b30c0129bf83",
        "storage_key": "property/6767906449167742/01a03e59-49a2-76df-981e-b30c0129bf83.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.emory.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6401157007639682133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emory-university",
      "poi_latitude": "33.7973735",
      "poi_longitude": "-84.3252791",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 404-727-6123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9797-741b-9826-f67bdb0bfd88",
        "storage_key": "property/6767906449167742/01a03e5a-9797-741b-9826-f67bdb0bfd88.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHU-KgPcG9YgRVZzdN2J61Vg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_3ae07cb41a848f71c8ec3df4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "poi_name": "Centers for Disease Control and Prevention",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 Clifton Rd NE, Atlanta, GA 30333, USA",
      "poi_short_description": "This federal facility for the prevention & spread of diseases offers exhibits at its nearby museum.",
      "poi_long_description": "This federal facility for the prevention & spread of diseases offers exhibits at its nearby museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-93d2-736e-b3bc-4e7d4962e11a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-93d2-736e-b3bc-4e7d4962e11a",
        "storage_key": "property/6767906449167742/01a03e5c-93d2-736e-b3bc-4e7d4962e11a.webp",
        "width": 971,
        "height": 1280
      },
      "poi_business_url": "https://www.cdc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1310566027616466354&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centers-for-disease-control-and-prevention",
      "poi_latitude": "33.799329",
      "poi_longitude": "-84.32858999999999",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 404-639-3311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167742/01a03e5c-a7ef-718c-b5fb-7561323da8c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a7ef-718c-b5fb-7561323da8c8",
        "storage_key": "property/6767906449167742/01a03e5c-a7ef-718c-b5fb-7561323da8c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsx8GO3oE9YgRsjXGwtsQMBI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    }
  ],
  "office_hours": [
    {
      "id": "ec_7da82cb10f7d683f88d43b9f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b7c7cbfb832e5459456aedfb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f1e8505cbf56bc8cb70e29cf",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_dc26a8a8c3299214a85a6b6b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_dd437bc615cfe96721fd6e5f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_29863dd903664b1da37e935d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_8dedbf4a793dccf5447f757f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Very pleased. Everyone seems to go out of their way to make a living here an outstanding experience",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_b32ade8cb6f8da2f03476002",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Great place.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_3309c5592f80d2c787b690a3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "it is great",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_357ae3a8e78d46998e5384bd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "It's almost like living at a resort, makes my life much easier with it's location, very helpful staff and great amenities.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_a10998f6700193d2cc5e3190",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown is a fantastic building. The staff is extremely attentive and very competent. The building feels very safe, and the other residents are all extremely polite. Highly recommend.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_ea41870679db0077b97977e9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "I moved to Ascent a couple of months ago, I was one of the first residents to move in. There were some slight issues in the unit, which is normal for a brand new building. However anytime I reported a problem, the management took care of it immediately. Im really amazed by the staff working at the building; and I mean everyone, from sales, to receptionists, to cleaning personnel, maintenance and the management; the entire team is very friendly and care a great deal for the residents. I was moving from Miami, the first two months I wasnt much at the building because my wife was still back in Miami. Last week she finally moved to Atlanta and the first thing she got when we stepped in the building was a bottle of wine and a birthday card from the management and admin staff. They knew it had been her birthday few days ago and had prepared this nice surprise for her. My wife was overwhelmed by the kindness of the people and she felt welcomed and more importantly, she felt at home already from day one.  I also like the people living in the building; it seems that they do put quality over sales volume and I find it very important. I know the screening process is rigorous because I had to go through it as well. I hope they continue to keep the high standards, this will definitively differentiate Ascent from the several options available in the area. Congratulations to the staff and a big thank you for making us feel truly at home.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_12daef8c6ed7d718059fe960",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Nicholas did a fantastic job showing me around and responding quickly to my questions/requests.  The amenities here are wild and everything is finished beautifully.  So all in all, between the service and the actually living space, this was the obvious choice to make when deciding what high rise to live in.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_0ba9d2c45bf1e325079df702",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Excellent office and facility team. Beautiful building with great features. Great location.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_269bb6d7a177f80e3873d25b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "I love living at Ascent Midtown! The staff is awesome and the community is beautiful. 10 out of 10!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_9da8debb11782765974d9465",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "So glad we made the choice to move to Ascent. Our apartment is bright and sunny and a perfect floor plan. The staff and building are excellent.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_c17b05951623a1cc9a141e5b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "The team here has been above and beyond helpful with everything since I moved in making it really feel like home.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_d72d2d08eba7b2270ada94be",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "My dog and I love Ascent! We love living in this part of town, and our unit, amenities, and building in general are beautiful. The employees here are friendly and welcoming, and they are always so sweet to my dog. He's a very timid boy but living here has helped him learn to love people!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_f6f0e671e8076c2d5811679b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown has an excellent location in Midtown where I can walk to work, to Whole Foods, and so much entertainment. Piedmont Park is only a few minutes walk. The interior finishes and high end appliances make my home impressive and yet very functional. Google Fiber is an option that I was looking for and makes working from home during this unprecedented time easy and without interruption. The concierge is amazing, they make the entire experience enjoyable and convenient with all services, alongside the management and maintenance team members! All needs are handled with a smile and patience. I truly just love it here!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_239406009250ceaab9e49465",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "High quality apartment complex with great staff and amenities!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_aee95d0a41f9b8d8f2e0ad5b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Thanks to the professionalism of Ascent Midtown Apartments, my leasing experience and move were quick and easy. Special thanks to Nicholas, Irina and Jonathan who went out of their way to assist me and to ensure that I have everything I need.  They have exceeded my expectations. I am so happy with my Ascent apartment, the extraordinary amenities and beautiful views.  I am truly enjoying living at Ascent and having access to all that Midtown offers.  I highly recommend living here!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_f63926cd698c5c09d011018b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "4",
      "name": "false",
      "text": "This is a good place to live",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_7a01c762be6bad7f3a1423cb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "This building is everything you can imagine plus more the staff is amazing, the amenities is amazing my apartment is very cozy and fit for me I love everything about it",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_bc066764f6cf6c3910ea13f7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "This is my first time living in a city community and coming home to ascent is the best part of my day",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_b704a0be2a8feb7845667ad2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Finding the perfect apartment in Atlanta is hard, but Im so glad I chose Ascent Midtown! Living here has been the best experience ever, from my tour to move in, Ive had a cohesive and luxury experience. Ascent Midtown has done an exceptional job of providing their residents with a great experience, given the current circumstances of the pandemic, theyve done a great hob with keeping the community safe, clean and still enjoyable",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_4608bd4b1a4e03da1b3ae232",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Love living at Ascent midtown. Great location, management/concierge and clean apartment including amenities.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_4fcdfeb6bbb46140f46debde",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "4",
      "name": "false",
      "text": "Helpful staff, good facilities and safe environment. Pleased I chose this place!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_99fc7ebc751d5f819b76d158",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "I moved in a couple of weeks ago and have had a great experience. The facilities work well as intended. But, it’s the people working here that make this place very special. For example, Korhan, the maintenance supervisor was extremely helpful when I wanted his assistance with setting up my TV in my apartment. He was prompt, helpful and very kind. Bryanna in the concierge has also been extremely helpful. She does her best to assist the residents with their requirements. She is very prompt and understanding. Jacky and Angelica in the concierge are also very efficient and supportive.\nOverall, I feel justified in my decision in choosing Ascent Midtown. Great facilities, and even better people.",
      "date": "false",
      "title": "Great People Great Facilities"
    },
    {
      "id": "ec_2d4e6d7932b1df2a72af98d6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "4",
      "name": "false",
      "text": "One of the nicest apartments in Midtown, with beautiful luxury amenities and helpful staff.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_ee51b103262e8391f8caa979",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Having lived in various communities in Emory and Midtown Atlanta area this community feels the safest and best kept of any we have been in or visited.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_8fa9584d691d0912204f836b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "4",
      "name": "false",
      "text": "I have only been living at Ascent for a couple of weeks and I'm already in love! The view is EVERYTHING! I am enjoying all of the amenities as well as the monthly happenings/events that are held in the Ascent community.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_d70cbb4814fae3afb915b407",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "4",
      "name": "false",
      "text": "Ascent midtown is a wonderful place to live. The employees are friendly, efficient, and classy. I have never encountered an issue living here that is worth mentioning. The amenities are great, they host events which are very fun and allow you to meet your neighbors, the elevators are super fast, the appliances are modern, and the maintenance is timely and efficient. I have nothing bad to say about this place.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_199cdb3673be40a09ee23593",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "It is a great walking community.  The property and the views are simply amazing.  I love the rooftop to go read and just enjoy the view of the city.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_4018e6ec4055afbb20caadc5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Being retired military I have moved quite a bit and I must say the staff at Ascent Midtown is possibly the best and most accommodating Ive come in contact with. My experience from the day I did my tour of the property to date has been nothing less of exceptional. The professionalism of the staff in the Leasing Office is top notch in particularly Manny. I pray Im spelling his name correctlybut he goes above and beyond to ensure that the residents are being taken care of and have everything they need. Even though he sits in the leasing office he will get up from his desk to grab a package; hold a door; help you on the elevator or just to say hi. And he does it all with a smile. The other day, while standing in the lobby, I heard some other residence speaking of his kindness. Hes absolutely amazing!! Along with all the other staff. The building and its amenities give a resort style living experience. Its a very clean and inviting environment. I will and have recommended Ascent Midtown to friends and family looking to move to the area.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_e1776cfc148fdc502de6af24",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "This apartment goes above and beyond when it comes to quality. They don't cut any corners when it comes to appliances or amenities. I love it here - and the concierge and leasing office folks are SO kind and helpful!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_9a26a164905fa4c10fa85d73",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Kind and professional staffs. All areas are clean. Easy to get Marta station by walk.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_e536c8b8bdf3c2fea7ef2616",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown is an amazing place to stay!! The leasing office staff was incredibly nice and knowledgeable. Tamika, Jordan, Manny, Huan, and Johnathon are all amazing and played a vital role in getting me situated.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_a9bd312f7058318b79058783",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "I love it here. Best views, top-tier amenities, and great concierge!!!!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_341a6b68e3882a04fdcc651c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Fell in love with the property the first time I saw it. The amenities are everything. Also, everyone from the office staff to the maintenance crew have been nothing but helpful and friendly. Overall a great experience since I moved in.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_2cfd1c3c8d86d1390c7dcc3a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Ascent is a place where people from different backgrounds, cultures and nationalities live and make a beautiful and respectful community. The community events makes it fun to meet our neighbors and be part of the community.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_e8c82ba1bc409f9243a16b19",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Staff is so helpful and friendly. Quiet area, good neighbors as well.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_0c71dac94d2e8942853715ed",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown is a safe and secure property that is perfect for those looking for a luxurious residential experience. The amenities are amazing, the staff are pleasant and great at their roles, especially Jacob who is an excellent leasing agent, and the community feels like family. I would highly recommend Ascent Midtown to anyone looking for a new place to call home.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_90563aa9500dfb428f0ca19c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Jacob has been extremely accommodating. Quality apartment and great amenities",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_8ebef66b12a200e2603b6800",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown has made our move to our dream city a dream in itself. We love working with the lovely staff and have enjoyed our time living in the community.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_e957114e29b066dc0109997a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown is amazing and the management is very understanding and communicative. They definitely bring the community together.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_4d99a99c6c8f70a64b9e0a7c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown is a very clean, safe, and comfortable !",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_b55c654889604666a2fae12b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "4",
      "name": "false",
      "text": "Ascent so far is a really nice apartment besides the exception of having only four elevators only on the third/fourth floor in the parking garage but other than that the amenities are really nice , the view is gorgeous, good location it’s right next to everything you need , and its quiet in the apartment no loud noise at all . Which is very soothing to be in .",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_4c564695f5ebfb534649865f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "4",
      "name": "false",
      "text": "Ascent is a beautiful community with amazing amenities and staff. I love the community gatherings that are held monthly so we can get to know our neighbors.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_427ad238ed492b1413aa8c02",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "4",
      "name": "false",
      "text": "Located in the city center, there are many facilities nearby and it is very convenient. Also, the inside of the house is very tidy and satisfactory. I think it was a very good choice to live here.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_5cb43712496d52836d52b77f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "The leasing office and concierge service along with maintenance are excellent at what they do the hospitality and punctual ability they display are next level but the residents are the best reason for staying at the ascent they speak and are very friendly",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_4c9f77ad5c38c53118f8444f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown is high-quality living in a wonderful location. The amenities are top-notch and the staff are welcoming and helpful. I would recommend to my family and friends!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_cc9d39a1d7f66ff751e034f6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "4",
      "name": "false",
      "text": "Ascent is my first ever apartment on my own. I can honestly say I made the PERFECT choice. Absolutely love my 887 sq. foot apartment that sits right over the midtown area. Best apartment complex the city has to offer.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_5c93220e2957537d6dfe7eea",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "4",
      "name": "false",
      "text": "This apartment has many great amenities and features.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_cf6925915ba789ddc7fe0c68",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "The amenities are excellent and the location is good, so I am very satisfied. Additionally, events for residents are held periodically, for which I am very grateful.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_31102c295ebaf6a591a74e75",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown has - so far - exceeded my expectations. I love calling this my home. The amenities, the apartment finishes, the location - it’s all amazing.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_e7d665f41ceec5ae84ca12a9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "4",
      "name": "false",
      "text": "If you’re looking for a safe community with excellent management team and superb Maintenance team Ascent midtown  is where to go",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_b4ddb8610a37bf2253deb757",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "4",
      "name": "false",
      "text": "I really feel at home at this property. The staff feels like family and I love the design of my unit.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_be9a40659be2da95d7f143b1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown has been wonderful so far during our first month of residence. The move-in process was smooth and the vibe is warm and welcoming. Taye and Tameka have been especially awesome!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_f387330aa2a42e635c33c85d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "First time living in Atlanta. So glad I picked this place. The staff here is absolutely excellent!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_4e26c07c940c5a2604e1cecb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "I truly enjoy my living experience at Ascent Midtown. The concierge team is incredibly helpful, always going above and beyond to assist residents. The property is exceptionally well kept—clean, well-maintained, and it always smells fresh and inviting.\n\nI'm also grateful for the concessions I’ve received, which have made my time here even more enjoyable and stress-free. The location is unbeatable, with easy access to so many great shops and restaurants just steps away.\n\nThe amenities are beautiful and thoughtfully designed, adding real value to daily living. Overall, I’m very glad to call Ascent Midtown home!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_c2c6e6d255a6be17be442377",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Great community to live in! Jason and his team always go above and beyond. My maintenance request are always handled in a timely manner, and if there’s a reason it’s not handled in the first visit, they always keep me updated on the status",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_813c8bc841f040ae47cd8fa7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "My issues are a always addressed fast and efficiently.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_2643dbec8af4efb5bd14adbf",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "I love my place here. The team Diego, Z, and Taye are amazing. Concierge is accommodating. The mini market is convenient. The location is nearby everything. The building is clean, smells good, and in great condition. The maintenance guys Jon and Jeremy are knowledgeable and responsive. 10 out of 10.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_7071b8f6ac6e6a4a7a979d6f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Living at Ascent Midtown has been a seamless experience. The space feels intentional — from the design of the amenities to the overall energy of the community. It’s both refined and comfortable, creating a lifestyle that feels curated rather than just lived in. The team is attentive, and that consistency shows.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_df77ff7fa544df2f3e2578c7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown has definitely been one of my favorite places to live. I love large windows, floor to ceiling windows, and a nice view. This building has some of the best views in the city. The amenities are so beautiful & makes you feel like you’re living in a luxury magazine. From the pool cabanas, to the stunning rooftop, to the beautiful apartments. Truly one of the best buildings in Atlanta!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_caabaf74210f2aeca3d2be78",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "rating": "5",
      "name": "false",
      "text": "The pool is beautiful, staff is friendly, and apartments are elegant. After looking at multiple properties I’m glad I found this place.",
      "date": "false",
      "title": "Verified Renter"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "luxury-apartments-in-unit-laundry-atlanta",
      "search_query": "luxury apartments with in-unit laundry Atlanta",
      "category": "Amenity",
      "h1_title": "Luxury Apartments With In-Unit Laundry",
      "h2_subtitle": "Discover luxury living in the heart of Atlanta with our upscale apartments featuring in-unit laundry. Enjoy convenience and style in Midtown Atlanta.",
      "page_copy": "Experience modern elegance at Preferred, where luxury apartments with in-unit laundry await you in vibrant Midtown Atlanta. Our beautifully designed residences feature sleek stainless steel appliance packages and stylish chrome hardware, ensuring that every detail of your living space exudes sophistication. Each apartment boasts a stacked washer/dryer, offering unparalleled convenience to complement your busy lifestyle.\n\nLocated in the thriving cultural hub of Midtown Atlanta, Preferred places you in the center of it all. From the comfort of your home, relish in the views of the city and explore the vibrant community around you. Our apartments are thoughtfully curated with amenities like glass-tiled backsplashes and walk-in showers*, guaranteeing a premium living experience. Make Preferred your new home and indulge in the best of Atlanta living, perfectly balancing luxury and practicality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with In-Unit Laundry",
      "seo_description": "Explore luxury apartments with in-unit laundry in Midtown Atlanta, offering modern amenities and premium comfort at Preferred.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-park-fulton-county",
      "search_query": "pet friendly apartments with dog park Fulton County",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments with Dog Park",
      "h2_subtitle": "Explore our pet-friendly apartments in Fulton County, equipped with a dog park. Perfect for animal lovers seeking modern conveniences.",
      "page_copy": "Welcome to Preferred, where pet-friendly apartments with a dog park provide the ideal home for you and your furry friend in Fulton County. Our community is thoughtfully designed to accommodate pets, featuring a well-maintained dog park where your pet can play and meet other four-legged friends. Living at Preferred means you don’t have to compromise on style and function; our apartments feature stainless steel appliance packages and stylish chrome hardware.\n\nSituated in the vibrant surroundings of Midtown Atlanta, Preferred offers quick access to the best that Fulton County has to offer. Each apartment includes modern amenities like walk-in showers* and in-unit stacked washer/dryers, making it a haven for pet owners and families alike. Discover bright spaces with chic features like glass-tiled backsplashes that elevate your living experience. At Preferred, both you and your pet can enjoy a comfortable and luxurious lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments With Dog Park",
      "seo_description": "Discover pet-friendly apartments with a dog park in Fulton County at Preferred. Modern living in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "apartments-walk-in-shower-midtown-atlanta",
      "search_query": "apartments with walk-in shower Midtown Atlanta",
      "category": "Amenity",
      "h1_title": "Apartments with Walk-In Shower in Midtown",
      "h2_subtitle": "Find stylish apartments in Midtown Atlanta featuring luxurious walk-in showers. Experience refined living in the city’s vibrant heart.",
      "page_copy": "Preferred offers beautifully designed apartments with walk-in showers, set in the dynamic Midtown Atlanta. Our sophisticated living spaces are crafted for comfort and style, featuring top-tier amenities like stainless steel appliance packages and chrome hardware. The luxurious walk-in showers provide the perfect retreat after a busy day, elevating your daily routine with elegance and convenience.\n\nLocated in the bustling neighborhood of Midtown Atlanta, Preferred keeps you connected to the heart of the city while offering a peaceful sanctuary at home. Each apartment is thoughtfully appointed with features like a glass-tiled backsplash and a stacked washer/dryer for ultimate convenience. Enjoy the vibrant energy of Midtown, while unwinding in your spacious apartment that seamlessly blends comfort with modern design. Make Preferred your home and enjoy the unique amenities crafted to enhance your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Walk-In Shower Midtown",
      "seo_description": "Discover apartments with walk-in showers in Midtown Atlanta. Preferred offers luxury amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "green-living-apartments-electric-car-charging-30309",
      "search_query": "green living apartments electric car charging stations 30309",
      "category": "Amenity",
      "h1_title": "Green Living Apartments with EV Charging",
      "h2_subtitle": "Sustainable living meets convenience at our green apartments in 30309. Enjoy amenities like electric car charging stations.",
      "page_copy": "Embrace sustainability at Preferred, where green living apartments with electric car charging stations are part of your everyday lifestyle in Midtown Atlanta, 30309. Our community is committed to eco-friendly practices, offering dedicated spots to charge your electric vehicle. Nestled in a vibrant neighborhood, Preferred provides a perfect blend of modern features and environmental consciousness without compromising on style.\n\nEach apartment is elegantly designed with energy-efficient stainless steel appliances and chrome hardware packages that highlight our commitment to quality and sustainability. Indulge in the convenience of stacked washer/dryers in-unit, alongside luxurious details such as a glass-tiled backsplash. Situated in the heart of Atlanta's 30309 area, you’re just steps away from the city's best attractions while living in a community that prioritizes green initiatives.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Green Living Apartments with EV Charging 30309",
      "seo_description": "Experience green living in Midtown Atlanta, 30309. Preferred offers modern apartments with electric car charging stations.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "garaged-apartment-homes-near-piedmont-park",
      "search_query": "garaged apartment homes near Piedmont Park",
      "category": "Amenity",
      "h1_title": "Garaged Apartment Homes by Piedmont Park",
      "h2_subtitle": "Discover garaged apartment homes near the scenic Piedmont Park in Atlanta. Enjoy the blend of urban convenience and natural beauty.",
      "page_copy": "At Preferred, our garaged apartment homes offer the perfect urban living experience near the iconic Piedmont Park in Atlanta. Located in the desirable Midtown area, these homes provide easy access to both the vibrant city life and the tranquility of the park. Secure parking in our garages ensures your vehicle is protected, adding an extra layer of convenience to your lifestyle.\n\nOur apartments are equipped with premium features such as stainless steel appliance packages and elegant glass-tiled backsplashes. Each home includes chrome hardware and lighting packages, creating an atmosphere of sophistication. The convenience of in-home stacked washer/dryers and spacious walk-in showers* elevates your everyday living. Just a short walk from Piedmont Park, Preferred offers an ideal setting where you can enjoy city amenities without sacrificing green space.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Garaged Apartment Homes Near Piedmont Park",
      "seo_description": "Live near Piedmont Park in garaged apartment homes at Preferred. Enjoy urban living with natural surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "studio-apartments-midtown-atlanta",
      "search_query": "studio apartments midtown atlanta",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Midtown Atlanta",
      "h2_subtitle": "Discover modern studio apartments in Midtown Atlanta. Enjoy stylish living spaces with premium amenities in the city's energetic core.",
      "page_copy": "Preferred offers contemporary studio apartments in the heart of Midtown Atlanta, designed for modern urban living. Our studios are perfect for those who seek a compact yet sophisticated lifestyle, blended with the vibrant energy of Midtown's lively atmosphere. Each studio features stainless steel appliance packages and elegant glass-tiled backsplashes, ensuring a sleek and functional kitchen.\n\nSituated in one of Atlanta's most desirable neighborhoods, Preferred provides residents with luxurious amenities like chrome hardware and lighting packages. Enjoy the convenience of a stacked washer/dryer in every home, combined with thoughtfully designed interiors. Living in one of our studio apartments means you're steps away from Midtown's bustling cultural, dining, and entertainment scene, offering the best of city life right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Midtown Atlanta",
      "seo_description": "Explore stylish studio apartments in Midtown Atlanta at Preferred. Enjoy vibrant city living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-fulton-county",
      "search_query": "one bedroom apartments fulton county",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Fulton County",
      "h2_subtitle": "Experience spacious one bedroom apartments in the heart of Fulton County. Enjoy modern amenities and convenient city accessibility.",
      "page_copy": "Discover the charm of Fulton County living with our one bedroom apartments at Preferred. Located in the vibrant Midtown Atlanta area, these residences offer a perfect blend of comfort and metropolitan convenience. Our one bedroom layouts are thoughtfully designed, featuring spacious interiors complete with stainless steel appliance packages and stylish glass-tiled backsplashes that elevate your culinary experiences.\n\nEach apartment boasts luxurious chrome hardware and lighting packages, alongside the convenience of an in-home stacked washer/dryer. With a focus on delivering a superior living experience, Preferred ensures easy access to all that Fulton County has to offer, from cultural hotspots to dining and shopping destinations. Choose our one bedroom apartments and enjoy a lifestyle that seamlessly integrates urban excitement with modern comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Fulton County",
      "seo_description": "Explore one bedroom apartments in Fulton County at Preferred for modern living with excellent amenities and city access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-30309",
      "search_query": "two bedroom apartments near 30309",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 30309",
      "h2_subtitle": "Explore two bedroom apartments near the 30309 area. Spacious and well-equipped, these homes offer the ideal blend of comfort and convenience.",
      "page_copy": "Located at the intersection of luxury and convenience, Preferred's two bedroom apartments near the 30309 area code cater to those seeking a spacious and stylish living environment. Our residences provide ample room to relax and entertain, with features like stainless steel appliances and glass-tiled backsplashes that bring a touch of elegance to your kitchen. \n\nEnjoy high-end finishes throughout, including chrome hardware and lighting packages that complement the modern design. Each home includes a stacked washer/dryer, ensuring laundry convenience without leaving your apartment. These well-appointed two bedroom units offer not only superior amenities but also the advantage of a prime location, granting easy access to Midtown Atlanta’s cultural and entertainment offerings. Live in style and comfort with our thoughtfully designed homes near 30309.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 30309",
      "seo_description": "Discover two bedroom apartments near the 30309 area at Preferred. Spacious, modern living spaces in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "apartments-near-georgia-tech-midtown-atlanta",
      "search_query": "apartments near Georgia Institute of Technology Midtown Atlanta",
      "category": "School",
      "h1_title": "Apartments Near Georgia Tech Midtown Atlanta",
      "h2_subtitle": "Find chic apartments near Georgia Tech in Midtown Atlanta. Experience convenience and style minutes away from campus.",
      "page_copy": "Just steps from the Georgia Institute of Technology, Preferred offers upscale apartments ideal for students and professionals alike. Nestled in the vibrant heart of Midtown Atlanta, these residences provide the perfect balance of convenience and contemporary style. Our thoughtfully crafted homes come equipped with high-end finishes such as stainless steel appliance packages and glass-tiled backsplashes, ensuring a premium living experience.\n\nEnjoy features like chrome hardware and lighting packages that add a sophisticated touch to each apartment. The convenience of a stacked washer/dryer in every home adds to the appeal. Living at Preferred means being just minutes from Georgia Tech, making it effortless to commute for classes or work. Embrace the bustling energy of Midtown while enjoying the comfort and luxury of a community designed with you in mind.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Georgia Tech Midtown Atlanta",
      "seo_description": "Explore modern apartments at Preferred near Georgia Tech, Midtown Atlanta: luxury living close to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "living-close-to-emory-university-ga",
      "search_query": "living close to Emory University GA",
      "category": "School",
      "h1_title": "Living Close to Emory University, GA",
      "h2_subtitle": "Discover exceptional living close to Emory University, GA. Enjoy a blend of comfort and convenience at Preferred.",
      "page_copy": "Preferred offers a unique living experience close to Emory University, making it the perfect choice for students, faculty, and university staff. Situated in the vibrant neighborhood of Midtown Atlanta, these homes combine convenience with contemporary design. Each apartment is thoughtfully designed with stainless steel appliance packages and attractive glass-tiled backsplashes that elevate your living environment.\n\nOur apartments feature modern chrome hardware and lighting packages, while each home includes a stacked washer/dryer for your convenience. Living at Preferred places you within easy reach of Emory University, allowing you to enjoy a short commute alongside the dynamic cultural and culinary scene of Midtown Atlanta. Choose Preferred for a sophisticated, convenient lifestyle near Emory University, GA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to Emory University, GA",
      "seo_description": "Experience modern living at Preferred, close to Emory University, GA. Enjoy comfort and convenience in Midtown.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "georgia-state-university-apartments-fulton-county",
      "search_query": "Georgia State University apartments in Fulton County",
      "category": "School",
      "h1_title": "Georgia State University Apartments Fulton County",
      "h2_subtitle": "Find modern apartments near Georgia State University in Fulton County. Experience convenience and vibrant city life.",
      "page_copy": "Preferred offers modern living spaces ideal for those attending Georgia State University, located conveniently in Fulton County. Our apartments are designed with students and professionals in mind, offering ideal accommodations in the bustling heart of Midtown Atlanta. Enjoy luxurious features such as stainless steel appliance packages and chic glass-tiled backsplashes in every apartment. \n\nEach residence is enhanced with contemporary chrome hardware and lighting packages, providing a sophisticated atmosphere. With stacked washer/dryers in each home, everyday chores become effortless. Living at Preferred means you're just a short commute from Georgia State University, while benefiting from the cultural and recreational opportunities that Midtown has to offer. Experience a seamless blend of academic convenience and upscale urban living at Preferred.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Georgia State University Apartments Fulton County",
      "seo_description": "Discover stylish apartments at Preferred near Georgia State University in Fulton County. Live in luxury and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "housing-by-t-deck-atlanta",
      "search_query": "housing by T Deck Atlanta",
      "category": "School",
      "h1_title": "Housing by T Deck Atlanta",
      "h2_subtitle": "Explore premium housing options by T Deck in Atlanta. Preferred offers upscale living in an ideal location.",
      "page_copy": "Discover exceptional housing by T Deck in Atlanta at Preferred, where comfort meets urban sophistication. Located in Midtown, these residences are perfectly positioned near the bustling activity of Atlanta, ensuring you're never far from the action. Each apartment features elegant stainless steel appliance packages and sleek glass-tiled backsplashes, providing a touch of luxury in every detail.\n\nOur homes are designed with contemporary chrome hardware and lighting packages, enhancing the modern aesthetic throughout. The convenience of a stacked washer/dryer in each unit adds to the appeal, making day-to-day life easier. Situated just moments from T Deck, Preferred offers the perfect blend of accessibility and style, allowing residents to enjoy the vibrant culture and convenience that Midtown Atlanta has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing by T Deck Atlanta",
      "seo_description": "Discover upscale housing at Preferred by T Deck in Atlanta. Enjoy luxury and convenience in Midtown.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "apartments-near-scad-atlanta-midtown",
      "search_query": "apartments near SCAD Atlanta Midtown",
      "category": "School",
      "h1_title": "Apartments Near SCAD Atlanta Midtown",
      "h2_subtitle": "Discover modern apartments near SCAD Atlanta Midtown. Preferred offers stylish living in a prime location.",
      "page_copy": "Preferred boasts contemporary apartments close to SCAD Atlanta in Midtown, ideal for students seeking a blend of comfort and convenience. Positioned in the vibrant hub of Midtown Atlanta, these apartments offer seamless access to Savannah College of Art and Design, allowing residents to engage fully with their academic journey while enjoying the city's lively art scene.\n\nEvery home at Preferred includes stainless steel appliance packages and chic glass-tiled backsplashes, elevating the living experience. The modern chrome hardware and lighting packages complement the stylish interiors, and with a stacked washer/dryer in each unit, residents can enjoy an efficient, hassle-free lifestyle. Embrace the perfect balance between study and play by living at Preferred, where SCAD Atlanta Midtown is just a stone's throw away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near SCAD Atlanta Midtown",
      "seo_description": "Explore stylish living at Preferred near SCAD Atlanta Midtown. Enjoy luxury and convenience in the heart of Atlanta.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "apartments-near-grady-memorial-hospital-atlanta",
      "search_query": "apartments near Grady Memorial Hospital Atlanta",
      "category": "Hospital",
      "h1_title": "Apartments Near Grady Memorial Hospital",
      "h2_subtitle": "Find convenient apartments near Grady Memorial Hospital in Atlanta. Preferred offers comfort and an ideal location.",
      "page_copy": "Discover the perfect apartment home at Preferred, ideally located near Grady Memorial Hospital in Atlanta. This prime location in Midtown Atlanta offers healthcare professionals, patients, and students unparalleled access to the medical district while enjoying the vibrant city life. Each apartment home features premium stainless steel appliance packages and stylish glass-tiled backsplashes, enhancing your everyday living experience.\n\nResidents appreciate the modern design elements, including chrome hardware and elegant lighting packages, contributing to a sophisticated living environment. With a stacked washer/dryer in each unit, daily chores are simplified, allowing you to focus on what matters most. Experience the convenience of living near Grady Memorial Hospital while enjoying all the cultural and entertainment offerings that Midtown has to offer at Preferred.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Grady Memorial Hospital",
      "seo_description": "Live close to Grady Memorial Hospital at Preferred. Enjoy convenience and upscale living in Atlanta's Midtown.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "apartments-close-to-emory-university-hospital-midtown",
      "search_query": "apartments close to Emory University Hospital Midtown Fulton County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Emory University Hospital",
      "h2_subtitle": "Explore elegant apartments close to Emory University Hospital Midtown. Preferred offers upscale living in Fulton County.",
      "page_copy": "Preferred provides exquisite apartments conveniently close to Emory University Hospital Midtown, making it an excellent choice for healthcare professionals, faculty, and students alike. Situated in Midtown Atlanta, within Fulton County, our community blends urban living with unparalleled comfort. Each apartment boasts top-notch features like stainless steel appliance packages and sophisticated glass-tiled backsplashes, ensuring a stylish atmosphere.\n\nDesigned to meet modern living standards, our homes include chrome hardware and elegant lighting packages, enhancing each resident's experience. The convenience of having a stacked washer/dryer in each unit further simplifies daily routines. Living at Preferred not only places you near Emory University Hospital Midtown but also surrounds you with the vibrant energy and amenities of the bustling Midtown Atlanta district.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Emory University Hospital",
      "seo_description": "Find upscale apartments near Emory University Hospital Midtown at Preferred. Enjoy luxury living in Midtown, Fulton County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "apartments-near-atlanta-botanical-garden-midtown",
      "search_query": "apartments near atlanta botanical garden midtown",
      "category": "Park",
      "h1_title": "Apartments Near Atlanta Botanical Garden",
      "h2_subtitle": "Discover charming apartments near Atlanta Botanical Garden. Preferred offers luxurious living in Midtown Atlanta.",
      "page_copy": "Preferred offers stunning apartments close to the Atlanta Botanical Garden, ideal for nature lovers seeking a tranquil urban lifestyle. Nestled in the heart of Midtown Atlanta, these apartment homes provide a serene retreat with quick access to the lush landscapes and seasonal exhibits of the garden. Featuring premium stainless steel appliances and sleek glass-tiled backsplashes, our homes offer contemporary elegance at every turn.\n\nResidents enjoy modern amenities, such as chrome hardware and stylish lighting packages, enhancing their living experience. With each apartment equipped with a stacked washer/dryer, daily chores are both efficient and convenient. Experience the best of both worlds at Preferred: proximity to the beautiful Atlanta Botanical Garden and the vibrant city life of Midtown Atlanta.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Atlanta Botanical Garden",
      "seo_description": "Live close to Atlanta Botanical Garden at Preferred. Enjoy luxurious living and easy access to Midtown's vibrant attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "rental-spaces-close-to-piedmont-park-atlanta",
      "search_query": "rental spaces close to piedmont park atlanta",
      "category": "Park",
      "h1_title": "Rental Spaces Near Piedmont Park Atlanta",
      "h2_subtitle": "Explore inviting rental spaces near Piedmont Park in Atlanta. Preferred offers modern living in the heart of Midtown.",
      "page_copy": "Preferred offers premium rental spaces just a stone's throw from Piedmont Park, a beloved oasis in Atlanta. Located in the energetic core of Midtown, these spaces are ideal for those who value both proximity to nature and city conveniences. Enjoy the perfect balance with stylish interiors featuring top-tier stainless steel appliance packages and chic glass-tiled backsplashes.\n\nOur residents relish in the contemporary design with chrome hardware and tasteful lighting, exemplifying the upscale lifestyle at Preferred. Each unit includes a stacked washer/dryer, freeing up time for residents to explore Piedmont Park's scenic trails and recreational activities. Embrace the vibrant community atmosphere and lively events at Preferred while experiencing the best Midtown has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Spaces Near Piedmont Park Atlanta",
      "seo_description": "Find impeccable rental spaces near Piedmont Park at Preferred. Enjoy modern living in vibrant Midtown Atlanta.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "living-near-centennial-olympic-park-georgia",
      "search_query": "living near centennial olympic park georgia",
      "category": "Park",
      "h1_title": "Living Near Centennial Olympic Park Georgia",
      "h2_subtitle": "Experience the benefits of living near Centennial Olympic Park. Preferred offers convenient and stylish living in Midtown Atlanta.",
      "page_copy": "Preferred's prime location offers the perfect setting for living near Centennial Olympic Park in Georgia. Situated in the vibrant Midtown Atlanta neighborhood, residents can enjoy easy access to the park's rich history and numerous events throughout the year. Our apartments feature luxurious amenities like stainless steel appliance packages and eye-catching glass-tiled backsplashes, providing a contemporary and comfortable home environment.\n\nResidents benefit from sophisticated chrome hardware and elegant lighting packages, creating a refined ambiance. With stacked washers/dryers in every apartment, daily chores are a breeze, leaving more time for exploring Centennial Olympic Park's attractions and downtown Atlanta's cultural offerings. Choose Preferred for a dynamic living experience that blends city life with peaceful retreats in Midtown.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Centennial Olympic Park Georgia",
      "seo_description": "Discover the advantages of living near Centennial Olympic Park at Preferred. Enjoy convenient, stylish living in Midtown Atlanta.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "apartments-close-to-westside-park-fulton-county",
      "search_query": "apartments close to westside park fulton county",
      "category": "Park",
      "h1_title": "Apartments Near Westside Park Fulton County",
      "h2_subtitle": "Find luxurious apartments close to Westside Park, Fulton County. Preferred offers modern amenities in Midtown Atlanta.",
      "page_copy": "Experience the best of both city living and natural beauty at Preferred, with apartments conveniently located near Westside Park in Fulton County. Situated in Midtown Atlanta, these residences provide swift access to Atlanta's newest and largest green space, making it a sought-after location for outdoor enthusiasts.\n\nOur apartments come complete with high-end stainless steel appliance packages and chic glass-tiled backsplashes, enhancing the contemporary feel. Enjoy the elegance of chrome hardware and designer lighting in every room. Plus, with a stacked washer/dryer in each home, you'll have more time to explore the scenic trails at Westside Park. Choose Preferred for a perfect blend of nature and urban excitement in one of Georgia's most desirable counties.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Westside Park Fulton County",
      "seo_description": "Discover stylish apartments near Westside Park at Preferred, offering modern amenities centrally located in Midtown Atlanta.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "apartments-near-five-points-station-atlanta",
      "search_query": "apartments near Five Points station Atlanta",
      "category": "Transit",
      "h1_title": "Apartments Near Five Points Station Atlanta",
      "h2_subtitle": "Explore apartments near Five Points Station in Atlanta. Preferred offers exceptional transit convenience in vibrant Midtown.",
      "page_copy": "Discover the unmatched convenience of living at Preferred, with apartments situated close to Five Points Station in Atlanta. Located in the dynamic neighborhood of Midtown, Preferred provides hassle-free access to one of Atlanta's central transit hubs, perfect for those who commute or enjoy city exploration.\n\nOur apartments feature impeccable design with stainless steel appliance packages and stylish glass-tiled backsplashes, setting the standard for modern living. The inclusion of chrome hardware and advanced lighting solutions transforms each home into a sophisticated urban retreat. With a stacked washer/dryer in every unit, Preferred residents have more time to enjoy the cultural and culinary delights surrounding Five Points Station. Experience a lifestyle of ease and comfort in the heart of Atlanta.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Five Points Station Atlanta",
      "seo_description": "Find convenience with apartments near Five Points Station at Preferred, featuring modern amenities in Midtown Atlanta.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "midtown-atlanta-apartments-by-arts-center-transit",
      "search_query": "Midtown Atlanta apartments by Arts Center transit",
      "category": "Transit",
      "h1_title": "Midtown Atlanta Apartments by Arts Center Transit",
      "h2_subtitle": "Discover ideal Midtown Atlanta apartments by Arts Center transit. Preferred offers seamless city living with easy access to culture and convenience.",
      "page_copy": "Preferred offers Midtown Atlanta apartments perfectly positioned by the Arts Center transit station. This prime location places you in the heart of Atlanta's cultural district, providing easy access to museums, theaters, and a vibrant arts scene.\n\nOur stylish apartments boast sophisticated amenities like stainless steel appliances and elegant glass-tiled backsplashes, creating an upscale home environment. Residents will love the convenience of chrome hardware and designer lighting packages throughout. Each home includes a stacked washer/dryer, allowing more time to enjoy all that Midtown and Atlanta have to offer. Experience modern city living with Preferred, where culture and comfort meet just steps from Arts Center station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Midtown Atlanta Apartments by Arts Center Transit",
      "seo_description": "Experience cultural convenience with Midtown Atlanta apartments near Arts Center transit, offering modern amenities at Preferred.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "north-ave-station-nearby-apartment-listings-midtown",
      "search_query": "North Ave station nearby apartment listings Midtown",
      "category": "Transit",
      "h1_title": "Nearby Apartment Listings Midtown, North Ave Station",
      "h2_subtitle": "Explore our Midtown apartment listings near North Ave Station. Preferred brings convenience and modern living to the heart of Atlanta.",
      "page_copy": "Welcome to Preferred, where you'll find prime apartment listings in Midtown Atlanta conveniently located near North Ave Station. This strategic location offers exceptional commuting options for residents who wish to live in a vibrant and connected community.\n\nOur stylishly designed apartments feature top-of-the-line stainless steel appliances and chic glass-tiled backsplashes, creating a perfect setting for urban lifestyles. Every home at Preferred is equipped with chrome hardware and contemporary lighting, adding a touch of elegance and sophistication. Additionally, the convenience of having a stacked washer/dryer in each unit offers the luxury of more free time to explore Midtown's dynamic dining, entertainment, and cultural venues. Choose Preferred for the ultimate city-living experience with convenient access to North Ave Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Listings Near North Ave Station Midtown",
      "seo_description": "Find your home in Midtown Atlanta with apartment listings near North Ave Station at Preferred, offering modern amenities and great convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "fulton-county-ga-apartments-near-lindbergh-center",
      "search_query": "Fulton County GA apartments near Lindbergh Center",
      "category": "Transit",
      "h1_title": "Fulton County Apartments Near Lindbergh Center",
      "h2_subtitle": "Discover Fulton County apartments near Lindbergh Center. Preferred provides modern amenities and easy access to Atlanta's energetic lifestyle.",
      "page_copy": "At Preferred, find exceptional apartments located in Fulton County, GA, just a short distance from Lindbergh Center. These homes offer seamless access to transportation and all the exciting cultural and professional opportunities in Atlanta.\n\nEmbrace a lifestyle of luxury with our finely appointed apartments, complete with stainless steel appliances and elegant glass-tiled backsplashes. Our commitment to quality is evident in details like chrome hardware and designer lighting. Each unit at Preferred includes a convenient stacked washer/dryer, making daily tasks effortless so you have more time to explore Lindbergh Center's nearby attractions. Immerse yourself in a vibrant community while enjoying uncompromised apartment comforts at Preferred in Fulton County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fulton County Apartments Near Lindbergh Center",
      "seo_description": "Explore Fulton County GA apartments near Lindbergh Center at Preferred, offering modern amenities and a connected lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167742",
      "source": "generator",
      "page_item_url": "midtown-atl-living-close-to-midtown-station",
      "search_query": "Midtown ATL living close to Midtown station",
      "category": "Transit",
      "h1_title": "Midtown ATL Living by Midtown Station",
      "h2_subtitle": "Experience Midtown ATL living close to Midtown Station. Preferred offers modern amenities and city convenience in the heart of Atlanta.",
      "page_copy": "Preferred invites you to experience premium Midtown ATL living conveniently situated near Midtown Station. This sought-after location offers unparalleled access to everything Atlanta has to offer, from dynamic arts and entertainment venues to vibrant dining and shopping spots.\n\nOur elegantly designed apartments feature modern amenities, including stainless steel appliance packages and stunning glass-tiled backsplashes. With chrome hardware and sophisticated lighting packs, each home ensures a stylish living environment. Plus, with a stacked washer/dryer in every unit, residents enjoy more leisure time to embrace the vibrant lifestyle of Midtown ATL. At Preferred, enjoy urban living with the perfect balance of convenience and luxury, right next to Midtown Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a03e59-ee27-72ee-970b-c200b287a1c7",
        "storage_key": "property/6767906449167742/01a03e59-ee27-72ee-970b-c200b287a1c7.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Midtown ATL Living by Midtown Station",
      "seo_description": "Enjoy Midtown ATL living near Midtown Station with Preferred, featuring modern amenities and convenience in the heart of Atlanta.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImxGMGlBd2M4S2pOanJwbjZlWmpXSHc9PSIsInZhbHVlIjoiNmdSQkJEMklMWWl0SkJZdzdvajIxZz09IiwibWFjIjoiNWNlMGJmOTIzZTA4Nzc0YzUzOWM2N2I1YjM5MTQ0MTE1YTY3YzRjMWJlNTJmODE0OTExMGRhZGJiZjhjYTBhNSJ9"
    }
  ],
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImxGMGlBd2M4S2pOanJwbjZlWmpXSHc9PSIsInZhbHVlIjoiNmdSQkJEMklMWWl0SkJZdzdvajIxZz09IiwibWFjIjoiNWNlMGJmOTIzZTA4Nzc0YzUzOWM2N2I1YjM5MTQ0MTE1YTY3YzRjMWJlNTJmODE0OTExMGRhZGJiZjhjYTBhNSJ9"
};

export const generatedAt = '2026-08-26T20:54:33.879Z';
